import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useDropzone } from "react-dropzone";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import {
  Box,
  Button,
  Center,
  CloseIcon,
  Divider,
  FlatList,
  HStack,
  Image,
  Input,
  Modal,
  Pressable,
  Text,
  Tooltip,
  VStack,
} from "native-base";
import {
  AddIcon,
  AddPhotoIcon,
  BugReportIcon,
  EditIcon,
  FeatureRequestIcon,
  FeedbackIcon,
  MoreHorizontalIcon,
  Profile,
  GroupChatIcon,
} from "../../assets/icons/icon-assets";
import helping from "../../assets/images/helping.png";
import inform from "../../assets/images/inform.png";
import suspend from "../../assets/images/unsuspend.png";
import * as AV from "../../AVCore/AVCore";
import { AVEntity } from "../../AVCore/AVEntity";
import { Media } from "../../AVCore/Media";
import settings from "../../Platform/settings.json";
import { Loc } from "../../App/Loc";
import {
  setEntitydata,
  setEntityToken,
  setUser,
} from "../../Redux/Actions/userActions";
import { useWindowDimension } from "../../Utility/WindowDimensions";
import AVBody from "../../components/common/AVBody";
import AVCancel from "../../components/common/AVCancel";
import PreviewAlbums from "../../components/common/PreviewAlbums";
import { PageLoader } from "../../components/loaders";
import PlayersCard from "../../components/teams/PlayersCard";
import StaffsCard from "../../components/teams/StaffsCard";
import Createalbumpopup from "../Home/Createalbumpopup";
import AVInputtext from "../../components/AVInputtext";
import TabHeader from "../../components/common/TabHeader";
import AVCreateEventModal from "../../components/common/AVCreateEventModal";
import ProfileHeader from "../../components/common/ProfileHeader";
import RenderSeriesEvents from "../Events/RenderSeriesEvents";
import AVCreateTeam from "../../components/common/AVCreateTeam";
import AVPersonaModal from "../../components/common/AVPersonModal";
import AVConfirmationModal from "../../components/common/AVConfirmationModal";
import AVLeagueInvitePopup from "../../components/common/AVLeagueInvitePopup";
import CustomToast from "../../Hooks/useCustomToast";
import AVComDropdonwn from "../../components/common/AVComDropdown";
import useConvoChat from "../../Hooks/useConvoChat";
import useEntityMenuTabs from "../../Hooks/useEntityMenuTabs";
import _ from "lodash";
import {
  getAllNonRepeatingEvents,
  getEvent,
  getSeriesItem,
} from "../../Utility/utils";
import ErrorHandlerPopup from "../../components/common/ErrorHandlerPopup";
import AVFeedsProfile from "../Feeds/AVFeedsProfile";
import EntityProfilePic from "../../components/common/EntityProfilePic";
import { AVFeeCollection } from "../../components/common/EntityTabs/AVFeeCollection";
import { AVFeeCollectAbout } from "../../components/common/EntityTabs/AVFeeCollectAbout";
import { AVFeeCollectMembers } from "../../components/common/EntityTabs/AVFeeCollectMembers";
import { AVCardList } from "../../components/common/EntityTabs/AVCardList";
import { AVChatMessage } from "../../components/common/EntityTabs/AVChatMessage";
import AVConfirmLinkPopup from "../../components/common/AVConfirmLinkPopup";
import "driver.js/dist/driver.css";
import { driver } from "driver.js";

type ExtendedEntity =
  | AV.IAVEntity
  | AV.IEvent
  | AV.IGame
  | AV.ICollect
  | AV.IOrgBase
  | AV.IPlayerOrg
  | AV.IPerson;

interface ExtendedContact extends AV.INewStaff {
  parentName?: string;
  parentEmail?: string;
  parentPhone?: string;
}

type FlowType =
  | "teamMember"
  | "teamSeasonPlayer"
  | "clubMember"
  | "clubTermMember"
  | "eliteClubMember"
  | "schoolStaff"
  | "schoolYearStudent"
  | "groupMember"
  | "classStudent"
  | "gradClassStudent"
  | "organizationEmployee"
  | "neighborhoodNeighbors"
  | "communityMember"
  | "performancePlayer"
  | null;

type ValidFlow = Exclude<FlowType, null>;
const flowKeyMap: Record<ValidFlow, string> = {
  teamMember: "showTeamMemberTour",
  teamSeasonPlayer: "showTeamSeasonPlayerTour",
  clubMember: "showClubMemberTour",
  clubTermMember: "showClubTermMemberTour",
  eliteClubMember: "showEliteClubMemberTour",
  schoolStaff: "showSchoolStaffTour",
  schoolYearStudent: "showSchoolYearStudentTour",
  groupMember: "showGroupMemberTour",
  classStudent: "showClassStudentTour",
  gradClassStudent: "showGradClassStudentTour",
  organizationEmployee: "showOrganizationEmployeeTour",
  neighborhoodNeighbors: "showNeighborhoodNeighborsTour",
  communityMember: "showCommunityMemberTour",
  performancePlayer: "showPerformancePlayerTour",
};

const flows: ValidFlow[] = [
  "teamMember",
  "teamSeasonPlayer",
  "clubMember",
  "clubTermMember",
  "eliteClubMember",
  "schoolStaff",
  "schoolYearStudent",
  "groupMember",
  "classStudent",
  "gradClassStudent",
  "organizationEmployee",
  "neighborhoodNeighbors",
  "communityMember",
  "performancePlayer",
];

const Teams = (props: any) => {
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const type = params?.type;
  let viewTeam = location?.state?.team;
  const seriesId =
    params?.seriesId !== "undefined" && params?.seriesId !== undefined
      ? params?.seriesId
      : null;
  const teamType = location?.state?.teamType;
  const feedBackType = useMemo(
    () => location?.state?.type,
    [location?.state?.type],
  );
  const feedBackId = location?.state?.team?.id;
  const region = params?.region;
  const entityId = params?.entityId;
  const currentUser = useSelector(
    (state: RootStateOrAny) => state?.user?.user[0],
  );
  const entityDataList = useSelector(
    (state: RootStateOrAny) => state.user.entitydatalist,
  );
  let userConvo = useSelector((state: RootStateOrAny) => state.convo.convo[0]);
  const entityToken = useSelector(
    (state: RootStateOrAny) => state?.user.entityToken,
  );
  const isOnline = useSelector((state: RootStateOrAny) => state.user.isOnline);
  const rightRef = useRef<HTMLDivElement | null>(null);
  const [staffEmail, setStaffEmail] = useState("");
  const [staffPhone, setStaffPhone] = useState("");
  const [staffPic, setStaffPic] = useState("");
  const [albumList, setAlbumList] = useState([]);
  const [filesList, setFilesList] = useState([]);
  const [recordList, setRecordList] = useState([]);
  const [isCreate, setIsCreate] = useState(location?.state?.isCreate);
  const [isUpdate, setIsUpdate] = useState(true);
  const [isLoader, setLoader] = useState(false);
  const [isShowEdit, setIsShowEdit] = useState(false);
  const [isEditEntireSeries, setIsEditEntireSeries] = useState(false);
  const [showAddProfileModal, setShowAddProfileModal] = useState(false);
  const [isPlayer, setIsPlayer] = useState(true);
  const [isStaff, setIsStaff] = useState(false);
  const [isParticipant, setIsParticipant] = useState(false);
  const [showAddEventsModal, setShowAddEventsModal] = useState(false);
  const [groupList, setGroupList] = useState<AV.ILink[]>([]);
  const [orgList, setOrgList] = useState<AV.ILink[]>([]);
  const [playersList, setPlayersList] = useState<AV.IPlayer[]>([]);
  const [staffList, setStaffList] = useState<AV.IStaff[]>([]);
  const [editStaffItem, setEditStaffItem] = useState<AV.IStaff | null>(null);
  const [eventsList, setEventsList] = useState<AV.IEventLink[]>([]);
  const [entity, setEntity] = useState<ExtendedEntity>();
  const [leagueGameEntity, setLeagueGameEntity] = useState<ExtendedEntity>();
  const [seriesEventsList, setSeriesEventsList] = useState<AV.IEventLink[]>([]);
  const [isFeebackGroup, setIsFeedBackGroup] = useState(false);
  const [pageLoader, setPageLoader] = useState(true);
  const [isPicLoader, setIsPicLoader] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isHuddleData, setIsHuddleData] = useState<AV.ITypeLink | undefined>(
    undefined,
  );
  const [profile, setProfile] = useState({
    background: null,
    pic: null,
    thumb: null,
    gallery: null,
    previousPic: null,
    text: null,
    color: null,
  });
  const [repeatWeek, setRepeatWeek] = useState(false);
  const [isAdminView, setIsAdminView] = useState(false);
  const [isMember, setIsMember] = useState(false);
  const pathName = window.location.pathname;
  const [staffRole, setStaffRole] = useState<string | null>(null);
  const [locationAddress, setLocationAddress] = useState<AV.ILocationLink[]>(
    [],
  );
  const [googleMap, setGoogleMap] = useState("");
  const [isFollowing, setIsFollowing] = useState(false);
  const [isStaffEntity, setIsStaffEntity] = useState(false);
  const [isMemberEntity, setIsMemberEntity] = useState(false);
  const [isPlayerEntity, setIsPlayerEntity] = useState(false);
  const [showFileUploadModal, setShowFileUploadModal] = useState(false);
  const [contactList, setContactList] = useState<ExtendedContact[]>([]);
  const [contactMenu, setContactMenu] = useState<ExtendedContact | null>(null);
  const [error, setError] = useState<string | null>(null);
  const dimensions = useWindowDimension();
  const mobile = dimensions?.width < 600 || false;
  const [isDeleted, setIsDeleted] = useState(false);
  const [isSuspended, setIsSuspended] = useState(false);
  const [isStaffEdit, setIsStaffEdit] = useState(false);
  const [isShowPayPopup, setIsShowPayPopup] = useState(false);
  const isMobile = dimensions?.width <= 500 || false;
  const isLMobile = dimensions?.width <= 767 || false;
  const isTab = dimensions?.width <= 1300 || false;
  const [typeEvent, setTypeEvent] = useState("Social");
  const [isEditPlayerDetails, setIsEditPlayerDetails] = useState(false);
  const [newName, setNewName] = useState("");
  const [newMail, setNewMail] = useState("");
  const [newPhone, setNewPhone] = useState("");
  const [newParentName, setNewParentName] = useState("");
  const [newParentEmail, setNewParentEmail] = useState("");
  const [newParentPhone, setNewParentPhone] = useState("");
  const [isShowTeamsList, setIsShowTeamsList] = useState<AV.ILink[]>([]);
  const [fixedWidth, setFixedWidth] = useState<number>(0);
  const [isActives, setIsActives] = useState(false);
  const [isPractice, setIsPractice] = useState(false);
  const [isStaffReq, setIsStaffReq] = useState(false);
  const [isChildOrgReq, setIsChildOrgReq] = useState(false);
  const [staffDesc, setStaffDesc] = useState("");
  const [justi, setJusti] = useState("");
  const [childOrgOne, setChildOrgOne] = useState("");
  const [selectChildOrg, setSelectChildOrg] = useState<AV.ILink[]>([]);
  const [childOrgId, setChildOrgId] = useState<AV.ILink | null>(null);
  const [isDropList, setIsDropList] = useState(false);
  const [owner, setOwner] = useState<AV.IAVEntity | null>(null);
  const [isImagePopup, setIsImagePopup] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const target: AV.ITypeLink | undefined = entity
    ? AV.AVEntity.getFk(entity)
    : undefined;
  var sourceFK: AV.ITypeLink = AV.AVEntity.getFk(currentUser);
  const [isFilesView, setIsFilesView] = useState(true);
  const [isConfirmDelete, setIsConfirmDelete] = useState(false);
  const [confirmText, setConfirmText] = useState("Are you sure ?");
  const [selectType, setSelectType] = useState("");
  const [itemSelect, setItemSelect] = useState<any>("");
  const [isOngoingOrFuture, setIsOngoingOrFuture] = useState(false);
  const [isEntireSeriesAvailable, setIsEntireSeriesAvailable] = useState(false);
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const [isTeam, setIsTeam] = useState(false);
  const [searchTypes, setSearchTypes] = useState("");
  const [showCreateNewPage, setShowCreateNewPage] = useState(false);
  const [createType, setCreateType] = useState("");
  const [passEntity, setPassEntity] = useState<ExtendedEntity>();
  const [isOrgOpen, setOrgOpen] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [singleImage, setSingleImage] = useState();
  const [allImages, setShowAllImage] = useState<any>([]);
  const [restoreRefresh, setRestoreRefresh] = useState(false);
  const [isLoad, setIsLoad] = useState(false);
  const [isOpenConvo, setIsOpenConvo] = useState(false);
  const { handleSendSingleChat } = useConvoChat();
  const [isRotate, setIsRotate] = useState(false);
  const [isShowEditOccurence, setIsShowEditOccurence] = useState(false);
  const [isShowEditEntireSeries, setIsShowEditEntireSeries] = useState(false);
  const [isConvoData, setIsConvoData] = useState("");
  const [isMemberTab, setIsMemberTab] = useState<AV.ILink | null>(null);
  const [showUnauthorizedDetails, setShowUnauthorizedDetails] = useState(false);

  // Events Tab
  const [allEventData, setAllEventData] = useState<AV.IEventLink[]>([]);
  const [allEvents, setAllEvents] = useState<AV.IEventLink[]>([]);
  const [filteredEvents, setFilteredEvents] = useState<AV.IEventLink[]>([]);
  const [eventType, setEventType] = useState(Loc.currentLang.menu.current);
  const [isCalendarView, setIsCalenderView] = useState(true);
  const currentItem = seriesId
    ? (entity as AV.IEvent)?.seriesEvents?.find((se) => se.id === seriesId)
    : null;
  const [seriesEvent, setSeriesEvent] = useState(
    currentItem?.id ? currentItem : location?.state?.series,
  );
  const [isLoadingEvent, setIsLoadingEvent] = useState(false);

  // Huddles Tab
  const convoKeyMap: Record<string, string> = {
    S: "sConvo",
    M: "mConvo",
    P: "pConvo",
    N: "nConvo",
    W: "wConvo",
    X: "xConvo",
    Y: "yConvo",
    A: "aConvo",
  };

  const checkConvoExitorNot = (type: string) => {
    const key = convoKeyMap[type];
    return key ? entity?.[key] : "";
  };

  // School Entity
  const [schoolYearOrgList, setSchoolYearOrgList] = useState<AV.ILink[]>([]);
  const [isSchoolYearsOrgTabOption, setIsSchoolYearsOrgTabOption] =
    useState(false);

  const [clickedUrl, setClickedUrl] = useState("");
  const [showConfirmLinkPopup, setShowConfirmLinkPopup] = useState(false);

  const leagueTeamInviteFK: AV.ILink = location?.state?.leagueTeamInviteFrom;
  const [showLeagueTeamInvitePopup, setShowLeagueTeamInvitePopup] =
    useState(false);

  useEffect(() => {
    if (
      leagueTeamInviteFK !== undefined &&
      leagueTeamInviteFK?.id != undefined
    ) {
      setShowLeagueTeamInvitePopup(true);
    }
  }, [leagueTeamInviteFK]);

  //Tab Menus & HelpText
  const {
    menuTabs,
    helpText,
    isTeamsPage,
    isSeasonPage,
    isEventPage,
    isStaffPage,
    isHuddlePage,
    isMembersPage,
    isPhotoPage,
    isDocumentPage,
    isRecordsPage,
    isPlayerPage,
    isGroup,
    isHomePage,
    isResourses,
    isParticipantsPage,
    isDropDown,
    isOrganization,
    isSchoolTeamsPage,
    isSchoolYearsPage,
    isSchoolAlumniPage,
    isSchoolGradClassPage,
    isSchoolAlumniGradClassPage,
    isSchoolYearOrgPage,
    isSchoolYearGradClassPage,
    isOccurencePage,
    isFeeCollectionPage,
    isCollectAboutPage,
    isCollectMembersPage,
    isGameChatPage,
    isGamePostPage,
    isGameTeamsPage,
    isLeagueTeamsPage,
    isLeagueGamesPage,
    setIsTeamsPage,
    setIsHomePage,
    setIsDropDown,
    setIsOrganization,
    setIsCollectAboutPage,
    setIsCollectMembersPage,
    setIsGameChatPage,
    resetAllPages,
    handleCollectMembersClick,
    handleGameChatClick,
    handleHomeClick,
    handleHelpText,
  } = useEntityMenuTabs({
    entity,
    seriesId: params.seriesId,
    isAdminView,
    isFilesView,
    currentUser,
    leagueGameEntity,
  });

  // Tour Guide
  const [onboardingStep, setOnboardingStep] = useState<number>(0);
  const [onboardingFlow, setOnboardingFlow] = useState<FlowType>(null);

  const addPlayerBtnRef = useRef<HTMLDivElement | null>(null);

  const clearCurrentTourFlow = () => {
    if (!onboardingFlow) return;

    const key = flowKeyMap[onboardingFlow];
    localStorage.removeItem(key);

    setOnboardingFlow(null);
    setOnboardingStep(0);
  };

  useEffect(() => {
    console.log("useEffect1");
    if (!onboardingFlow) return;
    if (
      (onboardingFlow === "teamMember" ||
        onboardingFlow === "clubMember" ||
        onboardingFlow === "eliteClubMember" ||
        onboardingFlow === "schoolStaff") &&
      onboardingStep !== 3
    )
      return;
    if (
      (onboardingFlow === "teamSeasonPlayer" ||
        onboardingFlow === "performancePlayer" ||
        onboardingFlow === "clubTermMember" ||
        onboardingFlow === "schoolYearStudent" ||
        onboardingFlow === "groupMember" ||
        onboardingFlow === "classStudent" ||
        onboardingFlow === "gradClassStudent" ||
        onboardingFlow === "organizationEmployee" ||
        onboardingFlow === "neighborhoodNeighbors" ||
        onboardingFlow === "communityMember") &&
      onboardingStep !== 2
    )
      return;
    if (
      onboardingFlow === "teamMember" ||
      onboardingFlow === "clubMember" ||
      onboardingFlow === "eliteClubMember" ||
      onboardingFlow === "schoolStaff"
    )
      return;
    if (
      (onboardingFlow === "teamSeasonPlayer" ||
        onboardingFlow === "performancePlayer" ||
        onboardingFlow === "clubTermMember" ||
        onboardingFlow === "schoolYearStudent" ||
        onboardingFlow === "groupMember" ||
        onboardingFlow === "classStudent" ||
        onboardingFlow === "gradClassStudent" ||
        onboardingFlow === "organizationEmployee" ||
        onboardingFlow === "neighborhoodNeighbors" ||
        onboardingFlow === "communityMember") &&
      !addPlayerBtnRef.current
    )
      return;

    let element: HTMLDivElement | null = null;
    let roleText = "";
    let stepTitle = "";

    switch (onboardingFlow) {
      case "teamSeasonPlayer":
      case "performancePlayer":
      case "clubTermMember":
      case "groupMember":
      case "performancePlayer":
        element = addPlayerBtnRef.current;
        roleText =
          onboardingFlow === "clubTermMember" ||
          onboardingFlow === "groupMember"
            ? Loc.currentLang.inviteTourGuide.members
            : Loc.currentLang.inviteTourGuide.players;
        stepTitle = Loc.currentLang.inviteTourGuide.step3_2;
        break;

      case "schoolYearStudent":
      case "classStudent":
      case "gradClassStudent":
        element = addPlayerBtnRef.current;
        roleText = Loc.currentLang.inviteTourGuide.students;
        stepTitle = Loc.currentLang.inviteTourGuide.step3_2;
        break;

      default:
        return;
    }

    if (!element) return;

    const tour = driver({
      showProgress: false,
      allowClose: true,
      overlayClickBehavior: () => {},
      showButtons: [],
      onCloseClick: () => {
        tour.destroy();
        clearCurrentTourFlow();
      },
      steps: [
        {
          element,
          popover: {
            title: stepTitle,
            description: `${Loc.currentLang.inviteTourGuide.clickPlus} ${roleText}.`,
            side: "left",
            align: "center",
          },
        },
      ],
      onPopoverRender: (popover) => {
        const footer = popover.wrapper.querySelector(
          ".driver-popover-footer",
        ) as HTMLElement;
        if (!footer) return;

        footer.innerHTML = "";
        footer.style.display = "flex";
        footer.style.justifyContent = "space-between";

        const skip = document.createElement("button");
        skip.innerText = Loc.currentLang.inviteTourGuide.skip;
        skip.className = "tour-btn-secondary";
        skip.onclick = () => {
          tour.destroy();
          clearCurrentTourFlow();
        };

        const right = document.createElement("div");
        right.style.display = "flex";
        right.style.gap = "8px";

        const prev = document.createElement("button");
        prev.innerText = Loc.currentLang.inviteTourGuide.previous;
        prev.className = "tour-btn-secondary";
        prev.onclick = () => {
          tour.destroy();
          setOnboardingStep(
            onboardingFlow === "teamSeasonPlayer" ||
              onboardingFlow === "performancePlayer" ||
              onboardingFlow === "clubTermMember" ||
              onboardingFlow === "schoolYearStudent" ||
              onboardingFlow === "groupMember" ||
              onboardingFlow === "classStudent" ||
              onboardingFlow === "gradClassStudent"
              ? 1
              : 0,
          );
        };

        const next = document.createElement("button");
        next.innerText = Loc.currentLang.inviteTourGuide.next;
        next.className = "tour-btn-primary";
        next.onclick = () => {
          tour.destroy();
          handleProfileType(
            onboardingFlow === "teamSeasonPlayer" ||
              onboardingFlow === "performancePlayer" ||
              onboardingFlow === "clubTermMember" ||
              onboardingFlow === "schoolYearStudent" ||
              onboardingFlow === "classStudent" ||
              onboardingFlow === "gradClassStudent"
              ? "Player"
              : "",
          );
          setOnboardingStep(
            onboardingFlow === "teamSeasonPlayer" ||
              onboardingFlow === "performancePlayer" ||
              onboardingFlow === "clubTermMember" ||
              onboardingFlow === "schoolYearStudent" ||
              onboardingFlow === "classStudent" ||
              onboardingFlow === "gradClassStudent"
              ? 3
              : 0,
          );
        };

        right.append(prev, next);
        footer.append(skip, right);
      },
    });

    setTimeout(() => tour.drive(), 100);
  }, [onboardingFlow, onboardingStep]);

  //Reload
  const handleOnline = () => {
    window.location.href = window.location.origin;
    window.location.reload();
  };

  // Add event listener for online event
  window.addEventListener("online", handleOnline);

  //Remove staff
  const handleRemoveStaff = async (item) => {
    setContactList(contactList?.filter((x) => x !== item));
  };

  //Styling
  const customSelectStyle = {
    maxHeight: "40px", // Set your desired height here
    width: "230px",
  };

  const customSelectStyleeeess = {
    maxHeight: "32px", // Set your desired height here
  };

  //Restore account
  const HandleRestoreAccount = () => {
    setIsConfirmDelete(true);
    setConfirmText(Loc.currentLang.menu.areYouSureYouWantToRestoreYourAccount);
    setItemSelect(entity);
    setSelectType("RestoreAccount");
  };

  const handleRestore = async () => {
    setLoader(true);

    if (entity?.status === "Deleted") {
      await AV.AVEntity.unDelete(entity);
      entity.status = "";
      entityDataList[
        entityDataList.indexOf(
          entityDataList?.find((x) => x?.id === entity?.id),
        )
      ] = entity;
      dispatch(setEntitydata(entityDataList));
      let index = currentUser?.orgs?.findIndex((x) => x?.id === entity?.id);
      if (index !== -1) {
        currentUser.orgs[index].hidden = "";
        dispatch(setUser(currentUser));
      }
    } else await AV.AVEntity.unSuspend(entity!);
    setLoader(false);
    setIsConfirmDelete(false);
    setRestoreRefresh(!restoreRefresh);
  };

  const handleConfirmToggleSilence = (item) => {
    const isSilenced = currentUser?.silenced?.some((x) => x?.id === item?.id);
    setIsConfirmDelete(true);
    setConfirmText(
      isSilenced
        ? Loc.currentLang.menu.areYouSurewantToUnSilence
        : Loc.currentLang.menu.areYouSurewantToSilence,
    );
    setItemSelect(item);
    setSelectType("ToggleSilence");
  };

  const handleToggleSilence = async () => {
    if (!itemSelect || !itemSelect.id) return;

    try {
      setLoader(true);
      const isSilenced = currentUser?.silenced?.some(
        (x) => x?.id === itemSelect.id,
      );

      if (isSilenced) {
        await AV.AVEntity.UnSilence(sourceFK, itemSelect);
      } else {
        await AV.AVEntity.silence(sourceFK, itemSelect);
      }

      const userUpdate = await AV.Person.getSelf();
      if (userUpdate?.id) {
        dispatch(setUser(userUpdate));
      }
    } catch (error) {
      console.error("Silence action failed:", error);
    } finally {
      setLoader(false);
      setIsOpen(!isOpen);
      setSelectType("");
      setIsConfirmDelete(false);
      setConfirmText("");
      setItemSelect("");
    }
  };

  //Remove Participant
  const HandleRemoveParticipant = (item) => {
    setIsConfirmDelete(true);
    setConfirmText(Loc.currentLang.menu.deleteParticipantConfirmText);
    setItemSelect(item);
    setSelectType("DeleteParticipant");
  };

  const RemoveParticiapnt = async () => {
    if (!entity) return;

    setLoader(true);
    try {
      const eventEntity = entity as AV.IEvent;
      let fk = AV.AVEntity.getFk(eventEntity);
      let occurId: string | null = null;

      if (
        eventEntity.eventType !== "Social" &&
        eventEntity.eventType !== "Show" &&
        eventEntity.type !== "Game"
      ) {
        if (eventEntity.series && eventEntity.id !== eventEntity.series) {
          occurId = eventEntity.id ?? "";

          fk = {
            id: eventEntity.series,
            pk: eventEntity.pk,
            region: eventEntity.region,
            type: eventEntity.type,
          };
        } else if (
          eventEntity.eventType === "Meeting" ||
          eventEntity.eventType === "Practice"
        ) {
          occurId = isEditEntireSeries
            ? null
            : seriesId !== "undefined"
              ? seriesId
              : null;

          if (eventEntity.participants?.some((x) => x.id === itemSelect?.id)) {
            occurId = null;
          }
        }
      }

      const updatedEvent = await AV.Event.removeParticipant(
        fk,
        itemSelect,
        occurId,
      );

      if (!updatedEvent) return;

      // Series occurrence
      if (eventEntity.series && eventEntity.id !== eventEntity.series) {
        const isAdminOrStaff =
          updatedEvent.status !== "Canceled" &&
          (updatedEvent.participants ?? []).some(
            (x) =>
              x.id === currentUser?.id &&
              (x.linkType === "Owner" || x.linkType === "Staff"),
          );

        setIsAdminView(isAdminOrStaff);
      } else {
        setEntity(updatedEvent);

        const index = entityDataList.findIndex((x) => x.id === updatedEvent.id);

        if (index !== -1) {
          const updatedEntityList = [...entityDataList];
          updatedEntityList[index] = updatedEvent;
          dispatch(setEntitydata(updatedEntityList));
        }
      }
    } finally {
      setLoader(false);
      setIsConfirmDelete(false);
    }
  };

  //Remove Resoruce
  const handleRemoveResourcePopup = (item) => {
    setIsConfirmDelete(true);
    setItemSelect(item);
    setConfirmText(
      Loc.currentLang.confirmationText.areYouSureYouWantToRemoveThisItem,
    );
    setSelectType("RemoveResource");
  };

  const handleRemoveResourses = async () => {
    if (!entity) return;

    setLoader(true);
    try {
      const event = entity as AV.IEvent;
      let occurId: string | null = null;

      // Social, Show and Game do not use occurrence IDs
      if (
        event.eventType !== "Social" &&
        event.eventType !== "Show" &&
        event.type !== "Game"
      ) {
        occurId =
          event.series && event.id !== event.series ? (event.id ?? "") : null;
      }

      // Meeting / Practice series handling
      if (event.eventType === "Meeting" || event.eventType === "Practice") {
        occurId = isEditEntireSeries
          ? null
          : seriesId && seriesId !== "undefined"
            ? seriesId
            : null;

        const resourceFound = (event.resources ?? []).some(
          (x) => x.resourceId === itemSelect?.resourceId,
        );

        if (resourceFound) {
          occurId = null;
        }
      }

      const updatedEvent = await AV.Event.removeResource(
        AV.AVEntity.getFk(event),
        itemSelect,
        occurId,
      );

      if (updatedEvent) {
        setEntity(updatedEvent);
      }
    } finally {
      setLoader(false);
      setItemSelect("");
      setSelectType("");
      setConfirmText("");
      setIsConfirmDelete(false);
    }
  };

  //Update Staff
  const handleUpdateStaff = async (item) => {
    let item1 = (entity as AV.IOrgBase)?.roles?.filter(
      (x) => x?.name === staffRole,
    )[0];
    const menu = { ...contactMenu };
    menu.role = item1;
    if (newName.trim()) menu.name = newName;
    if (newMail.trim()) menu.email = newMail;
    if (newPhone.trim()) menu.phone = newPhone;
    if (newParentName.trim()) menu.parentName = newParentName;
    if (newParentEmail.trim()) menu.parentEmail = newParentEmail;
    if (newParentPhone.trim()) menu.parentPhone = newParentPhone;
    setContactMenu(contactMenu);
    contactList[contactList.indexOf(item)] = menu;
    setContactList(contactList);
    setContactMenu(null);
    setIsEditPlayerDetails(false);
    setNewName("");
    setNewMail("");
    setNewPhone("");
    setNewParentName("");
    setNewParentEmail("");
    setNewParentPhone("");
  };

  //Addcontactlist
  const handleAddContactList = async () => {
    setIsLoading(true);
    setIsEditPlayerDetails(false);
    if (isStaffPage) {
      for (var i = 0; i < contactList.length; i++) {
        if (!contactList[i].role && (entity as AV.IOrgBase)?.roles?.[0]) {
          contactList[i].role = (entity as AV.IOrgBase).roles![0];
        }
      }
      let val = await AV.OrgBase.addStaffs(
        AV.AVEntity.getFk(entity!),
        contactList,
      );
      if (val) setStaffList(val?.staff ?? []);
    } else if (isMembersPage) {
      let member = await AV.AVEntity.addMembers(
        AV.AVEntity.getFk(entity!),
        contactList,
      );
    } else if (isPlayer) {
      let players = await AV.Team.addPlayers(
        AV.AVEntity.getFk(entity!),
        contactList,
      );
      if (players) {
        setPlayersList(players?.players ?? []);
      }
    } else if (isParticipant) {
      const orgEntity = entity as AV.IEvent;
      let seriesId =
        params?.seriesId !== "undefined" && params?.seriesId !== undefined
          ? params?.seriesId
          : null;
      seriesId =
        !isEditEntireSeries &&
        (orgEntity.series?.trim().length ?? 0) > 0 &&
        seriesId &&
        seriesId.trim().length > 0
          ? seriesId
          : null;
      let occurId =
        orgEntity?.eventType === "Show" || orgEntity?.eventType === "Social"
          ? null
          : seriesId;

      for (let i = 0; i < contactList?.length; i++) {
        const contact = contactList[i];

        let players = await AV.Event.addParticipant(
          AV.AVEntity.getFk(entity!),
          {
            title: contact.name,
            email: contact.email,
          },
          occurId,
        );

        if (players) {
          if (occurId !== null) {
            const seriesEvent =
              players?.seriesEvents?.find((x) => x.id === occurId) ??
              ({} as AV.ISeriesEvent);
            let AllParticipant = [
              ...(seriesEvent?.participants ?? []),
              ...(players?.participants ?? []),
            ];
            AllParticipant = _.uniqBy(AllParticipant, "id");

            // To sort the array so that items with linkType === 'Owner' or linkType === 'Staff' come first
            AllParticipant = AllParticipant?.sort((a, b) => {
              const getRank = (type) => {
                if (type === "Owner") return 0;
                if (type === "Staff") return 1;
                return 2; // for Participant or any other
              };
              return getRank(a.linkType) - getRank(b.linkType);
            });
          }
        }
      }
    }
    setIsLoading(false);
    setShowFileUploadModal(false);
    setShowAddProfileModal(false);
  };

  //Layout
  React.useLayoutEffect(() => {
    if (rightRef.current) {
      setFixedWidth(rightRef.current.offsetWidth - 2);
    }
  }, [[dimensions.width]]);

  //GetMedia
  const getMedia = async (file) => {
    let iMedia = await Media.saveFiles(
      AV.Media.getFormData(file),
      entity?.region ? entity?.region : currentUser?.region,
    );

    if (!iMedia || iMedia.length === 0) return;

    // Get uploaded link
    const srclink = AV.Media.getURL(iMedia[0]);
    if (!srclink) return;

    // Set metadata before saving
    iMedia[0].parent = AV.AVBase.getFk(entity ?? currentUser);
    //iMedia[0].linkURL = srclink;

    // Save uploaded media
    await AV.Media.saveMedia(iMedia);

    setLoader(false);
    setIsPicLoader(false);

    return iMedia[0];
  };

  const HandleRemoveplayers = (item) => {
    setIsConfirmDelete(true);
    const orgEntity = entity as AV.IOrgBase;
    setConfirmText(
      orgEntity?.subType === "Class" || orgEntity?.subType === "GradClass"
        ? Loc.currentLang.confirmationText.areYouSureYouWanttoDeleteYourStudents
        : orgEntity?.type === "PlayerOrg" && orgEntity?.subType === "Term"
          ? Loc.currentLang.confirmationText.areYouSureYouWanttoDeleteYourMember
          : Loc.currentLang.confirmationText
              .areYouSureYouWanttoDeleteYourPlayer,
    );
    setItemSelect(item);
    setSelectType("DeletePlayer");
  };

  const handleRemoveplayers = async () => {
    setLoader(true);
    let LeagueTeam = await AV.Team.removePlayer(AVEntity.getFk(entity!), {
      id: itemSelect.id,
      pk: itemSelect.pk,
      type: "Person",
    });
    if (LeagueTeam !== null) {
      setPlayersList(LeagueTeam?.players ?? []);
      setEntity(LeagueTeam);
    }
    setLoader(false);
    setIsConfirmDelete(false);
  };

  const HandleConfirmRemoveSchoolOrgs = (type, item) => {
    setItemSelect(item);
    setSelectType(type);
    setIsConfirmDelete(true);
    setConfirmText(Loc.currentLang.menu.deleteItemConfirmText);
  };

  const HandleRemoveSchoolOrgs = async () => {
    try {
      setLoader(true);

      if (selectType === "RemoveSchoolSeason") {
        const removeSeason = await AV.Team.removeSeason(
          AVEntity.getFk(entity!),
          itemSelect,
        );

        if (removeSeason) {
          setEntity(removeSeason);

          if (isSchoolGradClassPage) {
            // Remove GradClass from SchoolYear
            const yearEntity =
              (entity as AV.IOrgBase)?.childOrgs?.filter(
                (x) => x.type === "SchoolYear",
              ) ?? [];

            if (yearEntity.length > 0) {
              await AV.Club.removeGradClassFromYear(
                yearEntity[0],
                AV.AVEntity.getFk(itemSelect),
              );
            }
          } else if (isOrganization) {
            setOrgList([]);
            setSchoolYearOrgList(
              (removeSeason.childOrgs || []).filter(
                (x) => x.type !== "Collect",
              ),
            );
          }
        }
      } else if (
        isSchoolYearGradClassPage &&
        selectType === "RemoveSchoolGradClass"
      ) {
        const org = await AV.Club.removeGradClassFromYear(
          AV.AVEntity.getFk(entity!),
          itemSelect,
        );

        if (org) {
          setEntity(org);
        }
      }
    } catch (error) {
      console.error("Error removing school org:", error);
    } finally {
      setLoader(false);
      setIsOpen(false);
      setItemSelect("");
      setSelectType("");
      setIsConfirmDelete(false);
    }
  };

  const handleCreateEvent = (eventType) => {
    handleEventType(eventType);
    setTypeEvent(eventType);
    setLocationAddress([]);
    setIsActives(!isActives);
  };

  const handleCreateOrg = (type: string) => {
    setShowCreateNewPage(true);
    setCreateType(type);
    setPassEntity(entity);
    //setIsOrganization(false);
    setIsActives(false);
  };

  const HandleCreateGroup = () => {
    setShowCreateNewPage(true);
    setCreateType("Group");
    setPassEntity(entity);
    //setIsOrganization(false);
    setIsActives(!isActives);
  };

  const HandleTeamorg = () => {
    setShowCreateNewPage(true);
    setCreateType("Team");
    setPassEntity(entity);
    // setIsOrganization(false);
    setIsActives(!isActives);
  };

  const HandleClubOrg = () => {
    setShowCreateNewPage(true);
    setCreateType("Club");
    setPassEntity(entity);
    //setIsOrganization(false);
    setIsActives(!isActives);
  };

  const HandleClassOrg = () => {
    setShowCreateNewPage(true);
    setCreateType("Class");
    setPassEntity(entity);
    //setIsOrganization(false);
    setIsActives(!isActives);
  };

  const HandleGradOrg = () => {
    setShowCreateNewPage(true);
    setCreateType("GradClass");
    //setIsOrganization(false);
    setPassEntity(entity);
    setIsActives(!isActives);
  };

  const HandleOrg = () => {
    setShowCreateNewPage(true);
    setCreateType("Organization");
    //setIsOrganization(false);
    setPassEntity(entity);
    setIsActives(!isActives);
  };

  const HandleCreateSchoolChilds = (type: string) => {
    setShowCreateNewPage(true);
    setCreateType(type);
    setPassEntity(entity);
    //setIsSchoolTeamsPage(false);
    setIsActives(!isActives);
  };

  const dropdownComEventValues = [
    {
      id: 1,
      name: Loc.currentLang.menu.group,
      flag: allEventData,
      fn: HandleCreateGroup,
    },
    ...((entity as AV.IOrgBase)?.subType == "GradClass" ||
    (entity as AV.IOrgBase)?.subType == "Term"
      ? [
          {
            id: 1,
            name: Loc.currentLang.menu.team,
            flag: allEventData,
            fn: HandleTeamorg,
          },
        ]
      : []),
    ...((entity as AV.IOrgBase)?.subType == "GradClass"
      ? [
          {
            id: 2,
            name: Loc.currentLang.menu.club,
            flag: allEventData,
            fn: HandleClubOrg,
          },
        ]
      : []),
  ];

  const dropdownComOrgValues = [
    ...(entity?.type === "Organization" ||
    entity?.type === "Neighborhood" ||
    entity?.type === "Community" ||
    entity?.type === "School" ||
    entity?.type === "Club"
      ? [
          {
            id: 1,
            name: Loc.currentLang.menu.team,
            flag: allEventData,
            fn: HandleTeamorg,
          },
        ]
      : []),
    ...(entity?.type === "Organization" ||
    entity?.type === "Neighborhood" ||
    entity?.type === "Community" ||
    entity?.type === "School" ||
    entity?.type === "Club"
      ? [
          {
            id: 2,
            name: Loc.currentLang.menu.club,
            flag: allEventData,
            fn: HandleClubOrg,
          },
        ]
      : []),
    ...(entity?.type === "School"
      ? [
          {
            id: 3,
            name: Loc.currentLang.menu.classes,
            flag: allEventData,
            fn: HandleClassOrg,
          },
        ]
      : []),
    ...(entity?.type === "School"
      ? [
          {
            id: 4,
            name: Loc.currentLang.menu.graduatingClass,
            flag: allEventData,
            fn: HandleGradOrg,
          },
        ]
      : []),
    ...(entity?.type === "Organization"
      ? [
          {
            id: 5,
            name: Loc.currentLang.menu.organization,
            flag: allEventData,
            fn: HandleOrg,
          },
        ]
      : []),
    ...(entity?.type === "Community" ||
    entity?.type === "Organization" ||
    entity?.type === "School" ||
    entity?.type === "Club" ||
    entity?.type === "Neighborhood"
      ? [
          {
            id: 5,
            name: Loc.currentLang.menu.group,
            flag: allEventData,
            fn: HandleCreateGroup,
          },
        ]
      : []),
  ];

  const dropdownSchlYearsOrgValues = [
    ...[
      {
        id: 1,
        name: Loc.currentLang.menu.department ?? "Department",
        flag: allEventData,
        fn: () => HandleCreateSchoolChilds("Department"),
      },
    ],
    ...[
      {
        id: 2,
        name: Loc.currentLang.menu.class,
        flag: allEventData,
        fn: () => HandleCreateSchoolChilds("Class"),
      },
    ],
    ...[
      {
        id: 3,
        name: Loc.currentLang.menu.group,
        flag: allEventData,
        fn: () => HandleCreateSchoolChilds("Group"),
      },
    ],
    ...[
      {
        id: 4,
        name: Loc.currentLang.menu.team,
        flag: allEventData,
        fn: () => HandleCreateSchoolChilds("Team"),
      },
    ],
  ];

  const dropdownSchlDeptValues = [
    ...[
      {
        id: 1,
        name: Loc.currentLang.menu.group,
        flag: allEventData,
        fn: () => HandleCreateSchoolChilds("Group"),
      },
    ],
    ...[
      {
        id: 2,
        name: Loc.currentLang.menu.class,
        flag: allEventData,
        fn: () => HandleCreateSchoolChilds("Class"),
      },
    ],
    ...[
      {
        id: 3,
        name: Loc.currentLang.menu.club,
        flag: allEventData,
        fn: () => HandleCreateSchoolChilds("Club"),
      },
    ],
  ];

  //HandleUpload
  const handleUpload = useCallback(async (e) => {
    e.id = e.series ? e.series : e.id;
    let Team = await AV.AVEntity.save(e);
    if (Team) {
      setEntity(Team);
      setAlbumList(Team?.albums?.filter((x) => x.subType !== "Livestream"));
      setRecordList(Team?.albums?.filter((x) => x.subType === "Livestream"));
      let oldvalueOrgs = currentUser.orgs.filter((a) => a.id == Team?.id);
      if (oldvalueOrgs?.length > 0) {
        currentUser.orgs[currentUser.orgs.indexOf(oldvalueOrgs[0])] = Team;
        dispatch(setUser(currentUser));
      }
      let oldvalueOwned = currentUser.ownedEvents.filter(
        (a) => a.id == Team?.id,
      );
      if (oldvalueOwned?.length > 0) {
        currentUser.ownedEvents[
          currentUser.ownedEvents.indexOf(oldvalueOwned[0])
        ] = Team;
        dispatch(setUser(currentUser));
      }
      let oldvalueEvent = currentUser.events.filter((a) => a.id == Team?.id);
      if (oldvalueEvent?.length > 0) {
        let status = oldvalueEvent[0]?.status
          ? oldvalueEvent[0]?.status
          : "RSVP";
        currentUser.events[currentUser.events.indexOf(oldvalueEvent[0])] = Team;
        let Index = currentUser.events.findIndex((a) => a.id == Team?.id);
        if (Index !== -1) {
          currentUser.events[Index].status = status;
        }
        dispatch(setUser(currentUser));
      }

      let Index = entityDataList?.findIndex((x) => x?.id == Team?.id);
      if (Index !== -1) {
        entityDataList[Index] = Team;
        dispatch(setEntitydata(entityDataList));
      }
    }
  }, []);

  //Edit Profile
  const {
    getRootProps: getStaffProfilePicFile,
    getInputProps: getStaffProfileInputProps,
  } = useDropzone({
    accept: "image/*",
    onDrop: (acceptedFiles) => {
      if (
        acceptedFiles?.filter((x) => x?.type.startsWith("image")) &&
        acceptedFiles?.length > 0
      ) {
        setIsPicLoader(true);
        getMedia(acceptedFiles).then((res) => {
          if (!editStaffItem) return;
          editStaffItem.linkPic = res;
          setStaffPic(AV.Media.getURL(res));
        });
      } else {
        let clientError = { message: "Invalid file type" };
        CustomToast({ clientError });
        return;
      }
    },
  });

  const handleStaffRole = (e) => {
    e.preventDefault();
    setStaffRole(e.target.value);
  };

  const HandleRemoveMembers = (item) => {
    setIsConfirmDelete(true);
    setConfirmText(
      Loc.currentLang.confirmationText.areYouSureYouWanttoDeleteYourMember,
    );
    setItemSelect(item);
    setSelectType("DeleteMember");
  };

  const handleDeleteMember = async () => {
    setLoader(true);
    let removeMember = await AV.OrgBase.removeMember(AVEntity.getFk(entity!), {
      id: itemSelect.id,
      pk: itemSelect.pk,
      type: "Person",
    });
    if (removeMember !== null) {
      setEntity(removeMember);
    }
    setLoader(false);
    setIsConfirmDelete(false);
  };

  const handleRemoveChild = (item) => {
    setIsConfirmDelete(true);
    setConfirmText(
      Loc.currentLang.confirmationText.areYouSureYouWantToRemoveThisItem,
    );
    setItemSelect(item);
    setSelectType("DeleteChild");
  };

  const handleDeleteChild = async () => {
    setLoader(true);
    let removeSeason = await AV.Team.removeSeason(
      AVEntity.getFk(entity!),
      itemSelect,
    );

    if (removeSeason !== null) {
      setEntity(removeSeason);
      if (isOrganization) {
        setOrgList(
          removeSeason?.childOrgs?.filter(
            (x) => x?.type !== "Channel" && x?.type !== "Collect",
          ) ?? [],
        );
      } else {
        setGroupList(
          removeSeason?.childOrgs?.filter((x) => x?.type == "Group") ?? [],
        );
      }
    }

    setLoader(false);
    setIsOpen(!isOpen);
    setIsConfirmDelete(false);
  };

  const handleProfileType = async (type) => {
    if (type === "Player") {
      setIsPlayer(true);
      setIsStaff(false);
      setIsMember(false);
      setIsTeam(false);
      setIsParticipant(false);
    } else if (type == "Member") {
      setIsStaff(false);
      setIsPlayer(false);
      setIsMember(true);
      setIsTeam(false);
      setIsParticipant(false);
    } else if (type == "Participant") {
      setIsStaff(false);
      setIsPlayer(false);
      setIsMember(false);
      setIsTeam(false);
      setIsParticipant(true);
    } else if (type == "Group") {
      setIsStaff(false);
      setSearchTypes(
        entity?.type == "Group" && (entity as AV.IOrgBase)?.subType == undefined
          ? Loc.currentLang.menu.subGroup
          : Loc.currentLang.menu.group,
      );
      setIsPlayer(false);
      setIsMember(false);
      setIsParticipant(false);
      setIsTeam(true);
    } else if (type == "Organization" || type == "Teams" || type == "Years") {
      setIsStaff(false);
      setSearchTypes(Loc.currentLang.menu.organization);
      setIsPlayer(false);
      setIsMember(false);
      setIsParticipant(false);
      setIsTeam(true);
      setOrgOpen(false);
    } else {
      setIsPlayer(false);
      setIsMember(false);
      setIsStaff(true);
      setIsTeam(false);
      setIsParticipant(false);
    }

    setStaffPhone("");
    setError(null);
    setStaffRole("");
    setShowAddProfileModal(true);
  };

  const handleEditStaff = async (item) => {
    if (staffEmail) {
      if (!emailRegex.test(staffEmail)) {
        let clientError = { message: "Invalid Email" };
        CustomToast({ clientError });
        return;
      }
    }
    setIsLoading(true);
    setError("");
    let staff: AV.IStaff = item;
    let role: AV.IRole = staff?.role;
    staff.phone = staffPhone;
    staff.email = staffEmail;
    //staff.linkPic = staffpic;
    role.name = staffRole ?? "";
    let staffedit = await AV.OrgBase.updateStaff(
      AVEntity.getFk(entity!),
      staff,
    );
    if (staffedit) {
      setStaffList(staffedit?.staff ?? []);
    }
    setIsStaffEdit(false);
    setIsLoading(false);
  };

  const searchOrgs = async (val: string) => {
    setIsDropList(true);
    setChildOrgOne(val);

    setSelectChildOrg(
      currentUser?.orgs?.filter(
        (x) =>
          x?.type !== "Channel" &&
          ((x?.target?.title &&
            x.target.title
              .toLocaleLowerCase()
              .includes(val.toLocaleLowerCase())) ||
            (x?.title &&
              x.title.toLocaleLowerCase().includes(val.toLocaleLowerCase())) ||
            (x?.data &&
              x.data.toLocaleLowerCase().includes(val.toLocaleLowerCase()))),
      ),
    );
  };

  const handlestaffandorgReq = async () => {
    if (!target) return;

    setLoader(true);
    if (isStaffReq) {
      target.linkType = "StaffRequest";
      target.data = staffDesc;
      let resp = await AV.Person.makeRequest(sourceFK, target);
    } else if (childOrgId !== null) {
      const orgsourceFK = AV.AVEntity.getFk(childOrgId as AV.IAVEntity);
      target.linkType = "OrgParent";
      target.data = justi;
      let resp1 = await AV.Person.makeRequest(orgsourceFK, target);
    }
    setLoader(false);
    setStaffDesc("");
    setIsStaffReq(false);
    setChildOrgOne("");
    setJusti("");
    setIsChildOrgReq(false);
  };

  const GroupListItem = ({
    item,
    isAdminView,
    handleRemoveGroup,
    navigate,
  }) => {
    let cacheItem = entityDataList?.find((x) => x?.id == item?.id);
    if (cacheItem || currentUser?.id == item?.id)
      item =
        currentUser?.id == item?.id
          ? AV.AVEntity.getLink(currentUser)
          : AV.AVEntity.getLink(cacheItem);
    return (
      <Box
        key={item.id}
        bgColor={"#fff"}
        borderWidth={"1px"}
        borderColor={"AVColor.hovercolor2"}
        minWidth={130}
        minHeight={175}
        borderRadius={5}
        m={2}
        shadow={1}
      >
        {isAdminView && (
          <Pressable
            key={item.id}
            padding={1.5}
            rounded={"full"}
            position={"absolute"}
            right={-10}
            top={-10}
            zIndex={999}
            _hover={{ backgroundColor: "AVColor.hovercolor2" }}
            backgroundColor={"AVColor.buttonBg"}
            onPress={() => handleRemoveGroup(item)}
          >
            <CloseIcon size={"12px"} color={"AVColor.secondaryText"} />
          </Pressable>
        )}

        <VStack alignItems={"center"} height={"100%"} width={"100%"}>
          <Pressable
            key={item.id}
            height={"100%"}
            justifyContent={"center"}
            width={"100%"}
            _hover={{ bgColor: "#EEEEEE" }}
            onPress={() => {
              item?.type == "Person" || item?.type == "Pet"
                ? navigate(`/profile/${item?.id}/${item?.region}`, {
                    state: {
                      user: {
                        id: item?.id,
                        pk: item?.pk,
                        region: item?.region,
                        type: item?.type,
                        name: item?.title,
                      },
                    },
                  })
                : item?.type == "PlayerOrg"
                  ? navigate(`/season/${item?.id}/${item?.region}`, {
                      state: { isCreate: false, team: item },
                    })
                  : item?.type == "Group"
                    ? navigate(`/teams/${item?.id}/${item?.region}`, {
                        state: { isCreate: false, team: item },
                      })
                    : navigate(
                        `/organizations/${item?.id}/${item?.region}/${item?.type}`,
                        {
                          state: {
                            isCreate: false,
                            orgType: item?.type,
                            org: item,
                          },
                        },
                      );
            }}
          >
            {item?.thumb && (
              <Box
                bgColor={"#FF6600"}
                borderRadius={["full"]}
                width={"70px"}
                height={"70px"}
                alignSelf={"center"}
                p={0}
              >
                <Image
                  source={{
                    uri: AV.Media.getThumb(item),
                  }}
                  borderRadius={["full"]}
                  alt="Image"
                  width={"100%"}
                  height={["100%"]}
                />
              </Box>
            )}

            {!item?.thumb && (
              <Box
                bg="gray.100"
                borderRadius={["full"]}
                width={"70px"}
                height={"70px"}
                alignSelf={"center"}
                p={0}
              >
                <EntityProfilePic height={"70"} width={"70"} link={item} />
              </Box>
            )}

            <Tooltip label={item.title} openDelay={500}>
              <Pressable
                onPress={() => {
                  item?.type == "Person" || item?.type == "Pet"
                    ? navigate(`/profile/${item?.id}/${item?.region}`, {
                        state: {
                          user: {
                            id: item?.id,
                            pk: item?.pk,
                            region: item?.region,
                            type: item?.type,
                            name: item?.title,
                          },
                        },
                      })
                    : item?.type == "PlayerOrg"
                      ? navigate(`/season/${item?.id}/${item?.region}`, {
                          state: { isCreate: false, team: item },
                        })
                      : item?.type == "Group"
                        ? navigate(`/teams/${item?.id}/${item?.region}`, {
                            state: { isCreate: false, team: item },
                          })
                        : navigate(
                            `/organizations/${item?.id}/${item?.region}/${item?.type}`,
                            {
                              state: {
                                isCreate: false,
                                orgType: item?.type,
                                org: item,
                              },
                            },
                          );
                }}
              >
                <Text
                  marginTop={2}
                  left={"2px"}
                  alignItems="center"
                  width="120px"
                  numberOfLines={2}
                  textAlign="center"
                >
                  {item.title}
                </Text>
              </Pressable>
            </Tooltip>
          </Pressable>
        </VStack>
      </Box>
    );
  };

  const handledocument = async (item) => {
    let val = await AV.Media.getFile(item?.mListId, item.id, item?.storeId);
    if (val) {
      var blobUrl = val;
      var fileName = item?.orgFile;
      var a = document.createElement("a");
      a.href = blobUrl.toString();
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      // window.open(val);
    }
  };

  const HandleRemoveStaffs = (item) => {
    setIsConfirmDelete(true);
    setConfirmText(
      entity?.type == "School"
        ? "Are You Sure? You Want to Delete Your Adminstration"
        : "Are You Sure? You Want to Delete Your Staff",
    );
    setItemSelect(item);
    setSelectType("DeleteStaff");
  };

  const RemoveSeason = async () => {
    setLoader(true);
    let removeSeason = await AV.Team.removeSeason(AVEntity.getFk(entity!), {
      id: itemSelect.id,
      pk: itemSelect.pk,
      type: "Person",
      /*role: item.role,*/
    });
    if (removeSeason !== null) {
      setEntity(removeSeason);
    }
    setLoader(false);
    setIsConfirmDelete(false);
  };

  const RemoveStaffs = async () => {
    setLoader(true);
    let LeagueTeam = await AV.OrgBase.removeStaff(AVEntity.getFk(entity!), {
      id: itemSelect.id,
      pk: itemSelect.pk,
      type: "Person",
      role: itemSelect.role,
    });
    if (LeagueTeam) {
      setEntity(LeagueTeam);
      setStaffList(LeagueTeam?.staff ?? []);
    }
    setLoader(false);
    setIsConfirmDelete(false);
  };

  //GroupChat
  const HandleGroupChat = async (type: string) => {
    setIsLoad(true);

    if (type !== "A") {
      const isStaff = (entity as AV.IOrgBase)?.staff?.some(
        (x) => x.id === currentUser?.id,
      );
      const isPlayer = (entity as AV.IPlayerOrg)?.players?.some(
        (x) => x.id === currentUser?.id,
      );
      const isMember = (entity as AV.IOrgBase)?.members?.some(
        (x) => x.id === currentUser?.id,
      );

      let isParticipant = (entity as AV.IEvent)?.participants?.some(
        (x) => x.id === currentUser?.id,
      );

      if (
        !isParticipant &&
        ((entity as AV.IEvent)?.seriesEvents?.length ?? 0) > 0
      ) {
        const seriesEventData =
          (entity as AV.IEvent)?.seriesEvents?.find(
            (p) => p?.id === params.seriesId,
          ) || null;

        isParticipant =
          seriesEventData?.participants?.some(
            (p) => p?.id === currentUser?.id,
          ) || false;
      }

      if (!isStaff && !isPlayer && !isMember && !isParticipant) {
        setIsLoad(false);
        let clientError = {
          message: Loc.currentLang.menu.notAuthorizedGroupChat,
        };
        CustomToast({ clientError });
        return;
      }

      switch (true) {
        case isMembersPage:
          if (isStaff) type = "W";
          //else if (isMember && (entity as AV.IOrgBase)) type = "M";
          else if (isMember && (entity as AV.IPlayerOrg)) type = "M";
          else if (isMember && !(entity as AV.IPlayerOrg)) type = "M";
          else if (isPlayer && (entity as AV.IPlayerOrg)) type = "Y";
          break;

        case isPlayerPage:
          if (isStaff) type = "X";
          else if (isMember && (entity as AV.IPlayerOrg)) type = "Y";
          else if (isPlayer && (entity as AV.IPlayerOrg)) type = "P";
          break;

        case isStaffPage:
          if (isStaff) type = "S";
          else if (isMember && (entity as AV.IPlayerOrg)) type = "W";
          else if (isMember && !(entity as AV.IPlayerOrg)) type = "W";
          else if (isPlayer && (entity as AV.IPlayerOrg)) type = "X";
          break;

        case isParticipantsPage:
          if (isParticipant && (entity as AV.IEvent)) type = "N";
          break;

        default:
          break;
      }
    }

    const key = convoKeyMap[type];
    const validation = checkConvoExitorNot(type);

    // If convo already exists
    if (validation?.trim()?.length > 0) {
      const person = await AV.Person.getSelf(true);
      const huddleData = person?.orgs?.find((x) => x?.id === validation);

      navigate(`/huddles/${huddleData?.id ?? 1}`, {
        state: { HuddleData: huddleData },
      });

      setIsLoad(false);
      return;
    }

    // If convo doesn't exist, create
    if (!validation && target) {
      const response = (await AV.AVEntity.CreateGroupConvo(
        target,
        type,
      )) as AV.IAVEntity;
      console.log("Response", response);
      let Index = entityDataList?.findIndex((x) => x?.id == response?.id);
      if (Index !== -1) {
        entityDataList[Index] = response;
        setEntity(response);
      }
      dispatch(setEntitydata(entityDataList));

      const convoId = key ? response?.[key] : "";
      setIsConvoData(convoId);

      const person = await AV.Person.getSelf(true);
      dispatch(setUser(person));

      setTimeout(() => {
        const huddleData = person?.orgs?.find((x) => x?.id === convoId);

        navigate(`/huddles/${huddleData?.id ?? 1}`, {
          state: { HuddleData: huddleData },
        });

        setIsHuddleData(huddleData);
      }, 1000);
    }

    setIsLoad(false);
  };

  const getEntity = async (entityFK, activity = "") => {
    if (!entityFK?.id) return null;

    let entityData =
      entityDataList?.find((x) => x?.id === entityFK?.id) ?? null;

    if (!entityData) {
      let entityAPI: AV.IAVEntity | null = null;

      if (entityFK.type === "LeagueGameBase") {
        const param: AV.ILeagueGameParam = {
          source: entityFK,
          scoreType: activity,
        };
        entityAPI = await AV.Game.getLeagueGame(param);
      } else {
        entityAPI = await AV.AVEntity.get(entityFK);
      }

      if (entityAPI) {
        const updatedEntityData = [...(entityDataList || []), entityAPI];

        dispatch(setEntitydata(updatedEntityData));

        entityData = entityAPI;
      }
    }

    return entityData;
  };

  const EntityDataFinding = async (e) => {
    if (e) {
      setIsStaffEntity(e?.staff?.some((x) => x?.id === currentUser?.id));
      setIsMemberEntity(e?.members?.some((x) => x?.id === currentUser?.id));
      setIsPlayerEntity(e?.players?.some((x) => x?.id === currentUser?.id));

      setProfile(e?.profile);
      setIsDeleted(e?.status === "Deleted" ? false : true);
      setIsSuspended(e?.status === "Suspended" ? false : true);

      const isAdmin = e?.staff?.some((x) => x?.id === currentUser?.id);
      let isAdminOrStaff =
        e?.status == "Canceled"
          ? false
          : e?.participants?.some(
              (x) =>
                x?.id === currentUser?.id &&
                (x?.linkType === "Owner" || x?.linkType === "Staff"),
            );

      if (e.type !== "Collect") {
        setIsAdminView(isAdmin ? isAdmin : isAdminOrStaff);
        //setIsFutureEvent(isAdmin ? isAdmin : isAdminOrStaff);
      } else if (e?.type === "Collect") {
        const collectParent = entityDataList?.find(
          (item) => item?.id === e?.parent?.id,
        );

        if (collectParent) {
          if (
            (e?.parent?.type === "Event" || e?.parent?.type === "Game") &&
            collectParent?.parent?.type === "Person"
          ) {
            setIsAdminView(Boolean(e?.creator?.id === currentUser?.id));
          } else if (
            (e?.parent?.type === "Event" || e?.parent?.type === "Game") &&
            collectParent?.parent?.type !== "Person"
          ) {
            const collectEventParent = entityDataList?.find(
              (item) => item?.id === collectParent?.parent?.id,
            );

            if (collectEventParent) {
              let isAdminOrStaff = collectEventParent?.staff?.some(
                (x) => x?.id === currentUser?.id,
              );
              setIsAdminView(Boolean(isAdminOrStaff));
            }
          } else {
            const isAdmin = collectParent?.staff?.some(
              (member) => member?.id === currentUser?.id,
            );
            setIsAdminView(Boolean(isAdmin));
          }
        }
      }

      // For Event
      if (e.series) {
        let seriesParentEvent;
        var fk = {
          id: e.series,
          fk: e.series.slice(-4),
          type: e.type,
          region: e.region,
        };

        if (entityDataList?.filter((x) => x?.id === viewTeam?.id)?.length > 0) {
          seriesParentEvent = entityDataList?.filter(
            (x) => x?.id === viewTeam?.id,
          )[0];
        } else {
          seriesParentEvent = await AV.AVEntity.get(fk);
        }

        isAdminOrStaff =
          seriesParentEvent?.status == "Canceled"
            ? false
            : seriesParentEvent?.participants?.some(
                (x) =>
                  x?.id === currentUser?.id &&
                  (x?.linkType === "Owner" || x?.linkType === "Staff"),
              );

        const currentEvent = Array.isArray(e?.seriesEvents)
          ? e.seriesEvents.filter((x) => x.id === seriesId)
          : [];

        if (e?.seriesEvents?.length === 1 && isAdminOrStaff) {
          isAdminOrStaff =
            currentEvent?.[0]?.status === "Canceled" ? false : true;
        }

        const isEventCanceled = e?.status === "Canceled";

        //if (!isEventCanceled) {
        const currentEventObj = currentEvent.length > 0 ? currentEvent[0] : e;
        const isCurrentCanceled = currentEventObj?.status === "Canceled";

        const now = new Date();
        const isPast = new Date(currentEventObj?.end) < now;
        const isFuture = new Date(currentEventObj?.start) > now;
        const isOngoing =
          new Date(currentEventObj?.start) <= now &&
          now <= new Date(currentEventObj?.end);

        //if (!isCurrentCanceled) {
        setIsOngoingOrFuture(isFuture || isOngoing);
        setIsAdminView(isAdminOrStaff);
        console.log(
          `Event detected -> isFuture: ${isFuture}, isOngoing: ${isOngoing}, result: ${isFuture || isOngoing}`,
        );
        //} else {
        //  setIsAdminView(false);
        //  setIsOngoingOrFuture(false);
        //  console.log(
        //    "Event detected but canceled - isOngoingOrFuture: fasle",
        //  );
        //}

        // Any future occurrence event exists
        const hasFutureSeriesEvent = e?.seriesEvents.some(
          (evt) => evt.id !== currentEventObj?.id && new Date(evt.start) > now,
        );
        setIsEntireSeriesAvailable(hasFutureSeriesEvent);
        console.log("isEntireSeriesAvailable:", hasFutureSeriesEvent);
        //} else {
        //  setIsAdminView(false);
        //  setIsOngoingOrFuture(false);
        //  setIsEntireSeriesAvailable(false);
        //  console.log("Event detected but canceled - isOngoingOrFuture: fasle");
        //}
      }

      if (
        e?.type === "Event" ||
        e?.type === "Game"
        // || e?.type === "LeagueGameBase"
      ) {
        let entityParent =
          entityDataList?.find((x) => x?.id === e?.parent?.id) ?? null;
        if (!entityParent) {
          const entityAPI = await AV.AVEntity.get(e?.parent);

          if (entityAPI) {
            const updatedEntityData = [...(entityDataList || []), entityAPI];
            dispatch(setEntitydata(updatedEntityData));
            entityParent = entityAPI;
          }
        }

        let isStaffAdmin = entityParent?.staff?.some(
          (x) => x?.id === currentUser?.id,
        );
        setIsAdminView(Boolean(isStaffAdmin));
        setIsStaffEntity(Boolean(isStaffAdmin));
      }

      if (e?.albums) {
        setAlbumList(e?.albums?.filter((x) => x.subType !== "Livestream"));
        setRecordList(e?.albums?.filter((x) => x.subType === "Livestream"));
      }
      if (e?.files) {
        setFilesList(e?.files);
      }

      if (e?.childOrgs) {
        if (e.type === "SchoolYear") {
          setOrgList([]);
          setSchoolYearOrgList(
            e?.childOrgs?.filter(
              (x) => x?.type !== "Channel" && x?.type !== "Collect",
            ),
          );
        } else if (e.type !== "SchoolYear" /* && e.subType !== "Department"*/) {
          setOrgList(
            e?.childOrgs?.filter(
              (x) => x?.type !== "Channel" && x?.type !== "Collect",
            ),
          );
        }

        if (e.subType === "Department") {
          setGroupList(
            e?.childOrgs?.filter(
              (x) => x?.type !== "Channel" && x?.type !== "Collect",
            ),
          );
        } else {
          setGroupList(e?.childOrgs?.filter((x) => x?.type == "Group"));
        }
      }

      if (e?.parent?.type === "Person" && currentUser?.id == e?.parent?.id) {
        setOwner(currentUser);
        setIsAdminView(true);
        setIsStaffEntity(true);
      } else if (
        ["Team", "PlayerOrg", "Club", "School"].includes(e?.parent?.type) &&
        currentUser?.orgs?.some((x) => x?.id == e?.parent?.id)
      ) {
        setOwner(currentUser?.orgs?.find((x) => x?.id == e?.parent?.id));
      } else {
        if (e?.parent) {
          if (
            entityDataList?.filter((x) => x?.id === e?.parent?.id)?.length > 0
          ) {
            let parentEntity = entityDataList?.filter(
              (x) => x?.id === e?.parent?.id,
            );
            setOwner(parentEntity[0]);
          } else {
            let eventowner = (await AV.AVEntity.get(
              AV.AVEntity.getFk(e?.parent),
            )) as AV.IAVEntity;
            setOwner(eventowner);
          }
        }
      }

      const memberCheck =
        e?.members?.some((x) => x?.id === currentUser?.id) ?? false;

      const guardianCheck =
        e?.guardians?.some((x) => x?.id === currentUser?.id) ?? false;

      setIsFilesView(memberCheck || guardianCheck || isAdmin);

      if (e?.players) {
        setPlayersList(e?.players ?? []);
      }

      if (e?.staff) {
        setStaffList(e?.staff ?? []);
      }

      setIsShowTeamsList(e?.childOrgs);
      const loc = await AV.Media.getMap(e?.location);
      if (loc) {
        setGoogleMap(loc);
      }

      if (
        e?.eventType === "Show" ||
        e?.eventType === "Social" ||
        e?.type === "Game" ||
        e?.type === "LeagueGameBase" ||
        ((e?.eventType === "Meeting" || e?.eventType === "Practice") &&
          e?.seriesEvents?.length === 0)
      ) {
        const now = new Date();
        const isPast = new Date(e?.end) < now;
        const isFuture = new Date(e?.start) > now;
        const isOngoing = new Date(e?.start) <= now && now <= new Date(e?.end);
        setIsOngoingOrFuture(isFuture || isOngoing);
        console.log(
          `Event detected -> isFuture: ${isFuture}, isOngoing: ${isOngoing}, result: ${isFuture || isOngoing}`,
        );
      }

      if (
        leagueTeamInviteFK !== undefined &&
        leagueTeamInviteFK?.id != undefined
      )
        return;

      /* ---------------- TOUR GUIDE FLOW DETECTION ---------------- */
      for (const flow of flows) {
        const key = flowKeyMap[flow];
        const shouldShow = localStorage.getItem(key) === "true";

        if (!shouldShow) continue;

        switch (flow) {
          /* ---------- TEAM ---------- */
          case "teamMember":
            if (e?.type === "Team") {
              setOnboardingFlow(flow);
              setOnboardingStep(1);
              return;
            }
            break;

          case "teamSeasonPlayer":
            if (
              e?.type === "PlayerOrg" &&
              e?.parent?.type === "Team" &&
              e?.subType === undefined
            ) {
              setOnboardingFlow(flow);
              setOnboardingStep(1);
              return;
            }
            break;

          case "clubMember":
            if (e?.type === "Team" && e?.subType == "Club") {
              setOnboardingFlow(flow);
              setOnboardingStep(1);
              return;
            }
            break;

          case "clubTermMember":
            if (e?.type === "PlayerOrg" && e?.parent?.type === "Team") {
              setOnboardingFlow(flow);
              setOnboardingStep(1);
              return;
            }
            break;

          case "eliteClubMember":
            if (e?.type === "Club") {
              setOnboardingFlow(flow);
              setOnboardingStep(1);
              return;
            }
            break;

          case "schoolStaff":
            if (e?.type === "School") {
              setOnboardingFlow(flow);
              setOnboardingStep(1);
              return;
            }
            break;

          case "schoolYearStudent":
            if (e?.type === "SchoolYear") {
              setOnboardingFlow(flow);
              setOnboardingStep(1);
              return;
            }
            break;

          case "groupMember":
            if (e?.type === "Group" && e?.subType === undefined) {
              setOnboardingFlow(flow);
              setOnboardingStep(1);
              return;
            } else if (e?.type === "Group" && e?.subType === "Department") {
              setOnboardingFlow(flow);
              setOnboardingStep(1);
              return;
            }
            break;

          case "classStudent":
            if (e?.subType === "Class") {
              setOnboardingFlow(flow);
              setOnboardingStep(1);
              return;
            }
            break;

          case "gradClassStudent":
            if (e?.subType === "GradClass") {
              setOnboardingFlow(flow);
              setOnboardingStep(1);
              return;
            }
            break;

          case "organizationEmployee":
            if (e?.type === "Organization") {
              setOnboardingFlow(flow);
              setOnboardingStep(1);
              return;
            }
            break;

          case "neighborhoodNeighbors":
            if (e?.type === "Neighborhood") {
              setOnboardingFlow(flow);
              setOnboardingStep(1);
              return;
            }
            break;

          case "communityMember":
            if (e?.type === "Community") {
              setOnboardingFlow(flow);
              setOnboardingStep(1);
              return;
            }
            break;

          case "performancePlayer":
            if (e?.type === "PlayerOrg" && e?.subType === "MusicGroup") {
              setOnboardingFlow(flow);
              setOnboardingStep(1);
              return;
            }
            break;
        }
      }

      //let pastMeeting = false;
      //if (
      //  e.eventType === "Show" ||
      //  e.eventType === "Social" ||
      //  ((e.eventType === "Meeting" || e?.eventType === "Practice") &&
      //    e.seriesEvents?.length > 0)
      //) {
      //  pastMeeting = e.seriesEvents?.some((x) => new Date(x.end) < new Date());
      //}
      //setPastMeeting(pastMeeting);

      //if (e?.type !== "Event") {
      //  setIsFutureEvent(true);
      //  console.log("Event not detected - isOngoingOrFuture: true");
      //}
    }
  };

  const HandeFeedBackNavigate = (item) => {
    setIsFeedBackGroup(false);
    navigate(`/teams/${item?.id}/${item?.region}`, {
      state: { isCreate: false, team: item, type: "Feedback" },
    });
  };

  const handleEventType = (type) => {
    if (type == "Practice" || type == "Meeting") {
      setIsPractice(true);
      setRepeatWeek(true);
      setShowAddEventsModal(!showAddEventsModal);
      setIsActives(!isActives);
    } else if (type == "Show" || type == "Social") {
      setIsPractice(false);
      setShowAddEventsModal(!showAddEventsModal);
      setRepeatWeek(false);
    } else {
      setRepeatWeek(false);
      setShowAddEventsModal(!showAddEventsModal);
      setIsActives(!isActives);
    }
  };

  const openPreview = (item, allImages) => {
    setShowPreview(true);
    setSingleImage(item);
    allImages?.push(item);
    setShowAllImage(allImages);
  };

  const openPreviewprofile = (item, allImages) => {
    setShowPreview(true);
    setSingleImage(item);
    setShowAllImage([item]);
  };

  const findPersonInChats = (conversations, personToCheck) => {
    return conversations.find(
      (convo) =>
        convo?.subject === "" &&
        convo?.people?.some(
          (person) =>
            person?.id === personToCheck?.id &&
            person?.pk === personToCheck?.pk,
        ),
    );
  };

  const handleChat = async (item: AV.ILink) => {
    setIsMemberTab(item);
    setIsRotate(true);
    const people: AV.ILink[] = [];
    people?.push(item);
    let valid = await findPersonInChats(userConvo, item);
    if (valid?.id !== undefined) {
      setIsConvoData(valid?.id);
      setIsRotate(false);
      setIsOpenConvo(true);
      return;
    }
    let chatData = await handleSendSingleChat(people);
    if (chatData) {
      setIsConvoData(chatData?.id);
    }
    setIsRotate(false);
    setIsOpenConvo(true);
    setIsMemberTab(item);
  };

  const fetchAllEvents = async () => {
    try {
      if (entity === undefined || allEvents?.length > 0) {
        return false;
      }

      setIsLoadingEvent(true);
      const ownedEvents: AV.IEventLink[] = entity?.ownedEvents ?? [];
      const nonRepeatingEvents = ownedEvents.filter(
        (event) => !event.events || event.events.length === 0,
      );
      const repeatingEvents = ownedEvents.filter(
        (event) => event.events && event.events.length > 0,
      );

      const allRepeatingEvents: AV.IEventLink[] = [];
      const allNonRepeatingEvents: AV.IEventLink[] = [];

      for (const event of repeatingEvents) {
        let repeatedEvents = await getSeriesItem(event, currentUser);
        allRepeatingEvents.push(...repeatedEvents);
      }

      for (const event of nonRepeatingEvents) {
        let nonRepeatedEvents = await getAllNonRepeatingEvents(event);
        allNonRepeatingEvents.push(...nonRepeatedEvents);
      }

      let allEventList = [...allNonRepeatingEvents, ...allRepeatingEvents].sort(
        (a, b) => new Date(a.start).getTime() - new Date(b.start).getTime(),
      );
      setSeriesEventsList(allRepeatingEvents);
      setAllEventData(allEventList);
      setAllEvents(allEventList);
      setEventType(Loc.currentLang.menu.current);
      setFilteredEvents(
        allEventList.filter(
          (e) => new Date(e.start).getTime() >= new Date().getTime(),
        ),
      );
      setIsLoadingEvent(false);
      //HandleCurrent();
    } catch (error) {
      console.error("Error fetching events:", error);
    }
  };

  useEffect(() => {
    console.log("useEffect2");
    fetchAllEvents();
  }, [isCalendarView, isEventPage]);

  useEffect(() => {
    console.log("useEffect3");
    setEventsList(entity?.ownedEvents ?? []);
  }, [isEventPage]);

  useEffect(() => {
    console.log("useEffect4");
    if (entity?.type === "Collect" && !entity?.profile?.text && isAdminView) {
      handleCollectMembersClick();
    }
  }, [entity?.profile?.text, isAdminView]);

  useEffect(() => {
    console.log("useEffect5");
    if (
      ((entity?.type === "LeagueGameBase" && entity?.status === "Started") ||
        leagueGameEntity?.status === "Started") &&
      //!isGamePostPage &&
      !isRecordsPage &&
      isAdminView
    ) {
      handleGameChatClick();
    } else if (
      (entity?.type === "LeagueGameBase" && entity?.status === "Ended") ||
      leagueGameEntity?.status === "Ended" ||
      !isAdminView
    ) {
      handleHomeClick();
    }
  }, [(entity as AV.IGame)?.leagueGame, leagueGameEntity]);

  useEffect(() => {
    console.log("useEffect6");
    const updatedEntity = entityDataList?.find?.((x) => x?.id === entity?.id);

    if (!updatedEntity?.albums) return;

    const oldLiveAlbum = entity?.albums?.find(
      (x) => x?.subType === "Livestream",
    );
    const newLiveAlbum = updatedEntity?.albums?.find(
      (x) => x?.subType === "Livestream",
    );
    const oldCount = oldLiveAlbum?.data
      ? JSON.parse(oldLiveAlbum?.data).Count
      : 0;
    const newCount = newLiveAlbum?.data
      ? JSON.parse(newLiveAlbum?.data).Count
      : 0;

    if (oldCount !== newCount) {
      setEntity((prev) =>
        prev
          ? {
              ...prev,
              albums: updatedEntity?.albums,
            }
          : prev,
      );

      setRecordList(
        updatedEntity.albums?.filter((x) => x?.subType === "Livestream"),
      );
    }
  }, [entityDataList, entity?.id]);

  useEffect(() => {
    console.log("useEffect7");
    resetAllPages();
    if (entity?.type === "Collect") {
      setIsCollectAboutPage(
        ((entity as AV.IAVEntity)?.profile?.text?.trim().length ?? 0) > 0,
      );
      setIsCollectMembersPage(isAdminView && !entity?.profile?.text);
      setIsTeamsPage(false);
      setIsHomePage(false);
      setIsGameChatPage(false);
    } else if (
      ((entity?.type === "LeagueGameBase" && entity?.status === "Started") ||
        leagueGameEntity?.status === "Started") &&
      isAdminView
    ) {
      setIsGameChatPage(true);
      setIsCollectAboutPage(false);
      setIsCollectMembersPage(false);
      setIsTeamsPage(false);
      setIsHomePage(false);
    } else {
      setIsTeamsPage(true);
      setIsHomePage(true);
      setIsCollectAboutPage(false);
      setIsCollectMembersPage(false);
      setIsGameChatPage(false);
    }
  }, [createType, showCreateNewPage]);

  useEffect(() => {
    console.log("useEffect8");
    window.scrollTo(0, 0);
    async function fetchData() {
      if (
        location?.state?.isCreate ||
        entityId === "Create" ||
        entityId === "USD" ||
        entityId === "USC"
      ) {
        setIsCreate(true);
        setEntity(undefined);
        setProfile({
          background: null,
          pic: null,
          thumb: null,
          gallery: null,
          previousPic: null,
          text: null,
          color: null,
        });
        resetAllPages();
      } else if (
        !location?.state?.isCreate &&
        (isUpdate || entityId !== "Create")
      ) {
        setIsCreate(false);
        setIsUpdate(false);
        resetAllPages();
        setIsTeamsPage(viewTeam?.type !== "Collect");
        setIsCollectAboutPage(
          viewTeam?.type === "Collect" &&
            ((entity as AV.IAVEntity)?.profile?.text?.trim().length ?? 0) > 0,
        );
        setIsCollectMembersPage(
          isAdminView && viewTeam?.type === "Collect" && !entity?.profile?.text,
        );
        setIsGameChatPage(
          (viewTeam?.type === "Game" || viewTeam?.type === "LeaguGameBase") &&
            isAdminView,
        );

        //Entity Update Start
        if (
          (entityDataList?.filter((x) => x?.id === viewTeam?.id)?.length > 0 &&
            viewTeam) ||
          (viewTeam?.type && viewTeam?.type == "Event")
        ) {
          setPageLoader(true);

          if (viewTeam.type == "Event") {
            if (viewTeam.type == "Event" && viewTeam.seriesId) {
              setPageLoader(true);

              if (viewTeam.seriesId) {
                setPageLoader(true);

                let entitydata = entityDataList?.filter(
                  (x) => x?.id === viewTeam?.id,
                );
                if (entitydata?.length > 0) {
                  setEntity(entitydata[0]);
                  await EntityDataFinding(entitydata[0]);
                  //await handleSwitchTab(entitydata[0]);
                } else {
                  let actualEvent = await getEvent(viewTeam);
                  entityDataList?.push(actualEvent);
                  dispatch(setEntitydata(entityDataList));
                  await EntityDataFinding(actualEvent);
                  setEntity(actualEvent as AV.IAVEntity);
                  //await handleSwitchTab(ActualEvent);
                }
              }
              setPageLoader(true);
              if (
                entityDataList?.filter((x) => x?.id === viewTeam?.id)?.length >
                  0 &&
                !viewTeam.seriesId
              ) {
                //let ActualEvent : AV.IAVEntity = await getEvent(viewTeam);
                setEntity(
                  entityDataList?.filter((x) => x?.id === viewTeam?.id),
                );
                await EntityDataFinding(
                  entityDataList?.filter((x) => x?.id === viewTeam?.id),
                );
                //await handleSwitchTab(entityDataList?.filter(x => x?.id === viewTeam?.id));
              } else {
                if (viewTeam && !viewTeam.seriesId) {
                  await AV.AVEntity.get(AV.AVEntity.getFk(viewTeam)).then(
                    (e) => {
                      if (e == null) {
                        setShowUnauthorizedDetails(true);
                        return;
                      }

                      if (e) {
                        setEntity(e);
                        EntityDataFinding(e);
                        //handleSwitchTab(e);
                        entityDataList[
                          entityDataList.indexOf(
                            entityDataList?.find((x) => x?.id === viewTeam?.id),
                          )
                        ] = e;
                        dispatch(setEntitydata(entityDataList));
                      }
                    },
                  );
                }
              }
            } else {
              let IsPass =
                entityDataList?.filter((x) => x?.id === viewTeam?.id)?.length >
                0
                  ? true
                  : false;
              if (IsPass) {
                const now = new Date();
                const isFuture = new Date(viewTeam?.start) > now;
                const isOngoing =
                  new Date(viewTeam?.start) <= now &&
                  now <= new Date(viewTeam?.end);
                setIsOngoingOrFuture(isFuture || isOngoing);
                console.log(
                  `Event detected -> isFuture: ${isFuture}, isOngoing: ${isOngoing}, result: ${isFuture || isOngoing}`,
                );
                setEntity(entityDataList?.find((x) => x?.id === viewTeam?.id));
                await EntityDataFinding(
                  entityDataList?.find((x) => x?.id === viewTeam?.id),
                );
                //await handleSwitchTab(entityDataList?.find(x => x?.id === viewTeam?.id));
                if (viewTeam) {
                  AV.AVEntity.get(AV.AVEntity.getFk(viewTeam)).then((e) => {
                    if (e == null) {
                      setShowUnauthorizedDetails(true);
                      return;
                    }

                    if (e) {
                      setEntity(e);

                      EntityDataFinding(e);
                      //handleSwitchTab(e);
                      entityDataList[
                        entityDataList.indexOf(
                          entityDataList?.find((x) => x?.id === viewTeam?.id),
                        )
                      ] = e;
                      dispatch(setEntitydata(entityDataList));
                    }
                  });
                }
              } else {
                if (viewTeam) {
                  await AV.AVEntity.get(AV.AVEntity.getFk(viewTeam)).then(
                    (e) => {
                      if (e == null) {
                        setShowUnauthorizedDetails(true);
                        return;
                      }

                      if (e) {
                        setEntity(e);
                        EntityDataFinding(e);
                        //handleSwitchTab(e);
                        entityDataList?.push(e);
                        dispatch(setEntitydata(entityDataList));
                      }
                    },
                  );
                }
                setPageLoader(false);
              }
            }
          } else {
            console.log("step 02");
            setPageLoader(true);
            const entityData = entityDataList?.find(
              (x) => x?.id === viewTeam?.id,
            );
            setEntity(entityData);
            if (entityData?.type === "Game" && entityData?.leagueGame) {
              const leagueGame = await getEntity(
                entityData?.leagueGame,
                entityData?.scoreType,
              );
              setPassEntity(entityData);
              setLeagueGameEntity(leagueGame);
              console.log("leagueGame1: ", leagueGame);
            }
            if (entityData?.type === "LeagueGameBase") {
              setPassEntity(entityData);
              //setLeagueGameEntity(entityData);
              console.log("LeagueGameBase1: ", entityData);
            }
            await EntityDataFinding(entityData);
            //await handleSwitchTab(entityDataList?.find(x => x?.id === viewTeam?.id));
            if (!location?.state?.newEntity) {
              AV.AVEntity.get(AV.AVEntity.getFk(viewTeam)).then(
                async (result) => {
                  const e = result as AV.IAVEntity;
                  if (e == null) {
                    setShowUnauthorizedDetails(true);
                    return;
                  }

                  if (e) {
                    setEntity(e);
                    if (e?.type === "Game") {
                      const game = e as AV.IGame;
                      if (game.leagueGame) {
                        const leagueGame = await getEntity(
                          game.leagueGame,
                          game.scoreType,
                        );

                        setPassEntity(game);
                        setLeagueGameEntity(leagueGame);
                        console.log("leagueGame2: ", leagueGame);
                      }
                    }
                    if (e?.type === "LeagueGameBase") {
                      setPassEntity(e);
                      //setLeagueGameEntity(e);
                      console.log("LeagueGameBase2: ", e);
                    }
                    EntityDataFinding(e);
                    //handleSwitchTab(e);
                    entityDataList[
                      entityDataList.indexOf(
                        entityDataList?.find((x) => x?.id === viewTeam?.id),
                      )
                    ] = e;
                    dispatch(setEntitydata(entityDataList));
                  }
                },
              );
            }
          }
          setPageLoader(false);
        } else {
          console.log("step 03");
          setPageLoader(true);
          if (viewTeam && !viewTeam.seriesId) {
            console.log("step 04");
            await AV.AVEntity.get(AV.AVEntity.getFk(viewTeam)).then(
              async (result) => {
                const e = result as AV.IAVEntity;
                if (e == null) {
                  setShowUnauthorizedDetails(true);
                  return;
                }

                if (e) {
                  setEntity(e);
                  if (e?.type === "Game") {
                    const game = e as AV.IGame;
                    if (game.leagueGame) {
                      const leagueGame = await getEntity(
                        game.leagueGame,
                        game.scoreType,
                      );

                      setPassEntity(game);
                      setLeagueGameEntity(leagueGame);
                      console.log("leagueGame3: ", leagueGame);
                    }
                  }
                  if (e?.type === "LeagueGameBase") {
                    setPassEntity(e);
                    //setLeagueGameEntity(e);
                    console.log("LeagueGameBase3: ", e);
                  }
                  EntityDataFinding(e);
                  //handleSwitchTab(e);
                  entityDataList?.push(e);
                  dispatch(setEntitydata(entityDataList));
                }
              },
            );
          } else if (viewTeam && viewTeam.seriesId) {
            let e = (await getEvent(viewTeam)) as AV.IAVEntity;
            if (e) {
              setEntity(e);
              if (e?.type === "Game") {
                const game = e as AV.IGame;
                if (game.leagueGame) {
                  const leagueGame = await getEntity(
                    game.leagueGame,
                    game.scoreType,
                  );

                  setPassEntity(game);
                  setLeagueGameEntity(leagueGame);
                  console.log("leagueGame4: ", leagueGame);
                }
              }
              if (e?.type === "LeagueGameBase") {
                setPassEntity(e);
                //setLeagueGameEntity(e);
                console.log("LeagueGameBase4: ", e);
              }
              EntityDataFinding(e);
              //handleSwitchTab(e);
              entityDataList?.push(e);
              dispatch(setEntitydata(entityDataList));
            }
          } else {
            if (entityId !== "Create") {
              console.log("step 05");
              setPageLoader(true);
              var teamValue = currentUser?.orgs?.filter(
                (x) => x?.id === entityId,
              );
              if (teamValue?.length == 0) {
                teamValue = currentUser?.events?.filter(
                  (x) => x?.id === entityId,
                );
              }
              if (teamValue?.length == 0) {
                teamValue = currentUser?.ownedEvents?.filter(
                  (x) => x?.id === entityId,
                );
              }
              if (teamValue?.length == 0) {
                teamValue = entityDataList?.filter((x) => x?.id === entityId);
              }
              let targetFK = {
                Id: entityId,
                Pk: entityId?.substr(-4),
                Region: region,
                Type: "Team",
              };

              if (entityToken?.type) {
                console.log("useEffect8 entityToken", entityToken);
                targetFK = entityToken;
                dispatch(setEntityToken([]));
              }

              let e = (await AV.AVEntity.get(
                AV.AVEntity.getFk(
                  teamValue?.length > 0 ? teamValue[0] : targetFK,
                ),
              )) as AV.IAVEntity;

              if (e == null) {
                setShowUnauthorizedDetails(true);
                return;
              }

              if (e.type === "Event") {
                const event = e as AV.IEvent;

                if (
                  event.eventType === "Meeting" ||
                  event.eventType === "Practice"
                ) {
                  const currentEvent = Array.isArray(event?.seriesEvents)
                    ? event.seriesEvents.filter((x) => x.id === seriesId)
                    : [];
                  const currentEventObj =
                    currentEvent.length > 0 ? currentEvent[0] : event;
                  const now = new Date();
                  const isFuture = new Date(currentEventObj?.start) > now;
                  const isOngoing =
                    new Date(currentEventObj?.start) <= now &&
                    now <= new Date(currentEventObj?.end);
                  setIsOngoingOrFuture(isFuture || isOngoing);
                  console.log(
                    `Event detected -> isFuture: ${isFuture}, isOngoing: ${isOngoing}, result: ${isFuture || isOngoing}`,
                  );
                } else {
                  //const isFuture = new Date(e?.start) > new Date();
                  //setIsFutureEvent(isFuture);
                  //console.log("Event detected - isOngoingOrFuture:", isFuture);

                  if (e?.type !== "Event" && e?.type !== "Game") {
                    setIsOngoingOrFuture(true);
                    console.log("Event not detected - isOngoingOrFuture: true");
                  }
                }

                //await handleSwitchTab(e);
                setEntity(e);
                if (event?.type === "Game") {
                  const game = e as AV.IGame;
                  if (game.leagueGame) {
                    const leagueGame = await getEntity(
                      game.leagueGame,
                      game.scoreType,
                    );

                    setPassEntity(game);
                    setLeagueGameEntity(leagueGame);
                    console.log("leagueGame5: ", leagueGame);
                  }
                }
                EntityDataFinding(e);
                entityDataList?.push(e);
                dispatch(setEntitydata(entityDataList));
              }
              //AV.AVEntity.checkLinks(currentUser, e).then((x) => {
              //  dispatch(setUser(x));
              //  AV.Person.checkIfSelf(x);
              //});
              if (
                e?.id == "78b5b063-fd3e-4925-92bd-2a1888c6a46a" ||
                e?.id == "b495d4e0-bf52-4690-8dc0-677db954aa7f" ||
                e?.id == "b495d4e0-bf52-4690-8dc0-677db954aa71" ||
                e?.id == "b495d4e0-bf52-4690-8dc0-677db954aa72"
              ) {
                navigate(`/teams/${e?.id}/${currentUser?.region}`, {
                  state: {
                    team: {
                      id: e?.id,
                      pk: "a46a",
                      region: currentUser?.region,
                      type: "Organization",
                      name: "Actavivo",
                    },
                    type: "Feedback",
                  },
                });
              } else {
                if (e) {
                  setEntity(e);
                  if (e?.type === "Game") {
                    const game = e as AV.IGame;
                    if (game.leagueGame) {
                      const leagueGame = await getEntity(
                        game.leagueGame,
                        game.scoreType,
                      );

                      setPassEntity(game);
                      setLeagueGameEntity(leagueGame);
                      console.log("leagueGame6: ", leagueGame);
                    }
                  }
                  if (e?.type === "LeagueGameBase") {
                    setPassEntity(e);
                    //setLeagueGameEntity(e);
                    console.log("LeagueGameBase6: ", e);
                  }
                  EntityDataFinding(e);
                  //await handleSwitchTab(e);
                }
              }
            }
          }
          setPageLoader(false);
        }
      }
    }

    let isMounted = true;
    if (isMounted) {
      fetchData();
    }

    return () => {
      isMounted = false;
    };
  }, [entityId, viewTeam, /*entityDataList,*/ restoreRefresh]);

  useEffect(() => {
    console.log("useEffect9");
    if (entity?.type === "Collect") {
      setIsCollectAboutPage(
        ((entity as AV.IAVEntity)?.profile?.text?.trim().length ?? 0) > 0,
      );
      setIsCollectMembersPage(isAdminView && !entity?.profile?.text);
      setIsHomePage(false);
      setIsTeamsPage(false);
      setIsGameChatPage(false);
    } else if (
      ((entity?.type === "LeagueGameBase" && entity?.status === "Started") ||
        leagueGameEntity?.status === "Started") &&
      isAdminView
    ) {
      setIsGameChatPage(true);
      setIsCollectAboutPage(false);
      setIsCollectMembersPage(false);
      setIsHomePage(false);
      setIsTeamsPage(false);
    } else {
      setIsHomePage(true);
      setIsCollectAboutPage(false);
      setIsCollectMembersPage(false);
      setIsGameChatPage(false);
    }
  }, [showCreateNewPage]);

  useEffect(() => {
    console.log("useEffect10");
    let isMounted = true;
    if (isMounted) {
      handleHelpText();
    }
    return () => {
      isMounted = false;
    };
  }, [
    isHomePage,
    isTeamsPage,
    isEventPage,
    isMembersPage,
    isStaffPage,
    isPlayerPage,
    isPhotoPage,
    isGroup,
    isOrganization,
    isSeasonPage,
  ]);

  useEffect(() => {
    console.log("useEffect11");
    let isMounted = true;
    if (isMounted) {
      const following = currentUser?.follows;
      following?.filter((item) => item?.id === entity?.id).length > 0
        ? setIsFollowing(true)
        : setIsFollowing(false);

      if (entity?.type === "Collect") {
        setIsCollectAboutPage(
          ((entity as AV.IAVEntity)?.profile?.text?.trim().length ?? 0) > 0,
        );
        setIsCollectMembersPage(isAdminView && !entity?.profile?.text);
        setIsTeamsPage(false);
        setIsHomePage(false);
        setIsGameChatPage(false);
      } else if (
        ((entity?.type === "LeagueGameBase" && entity?.status === "Started") ||
          leagueGameEntity?.status === "Started") &&
        isAdminView
      ) {
        setIsGameChatPage(true);
        setIsCollectAboutPage(false);
        setIsCollectMembersPage(false);
        setIsTeamsPage(false);
        setIsHomePage(false);
      } else {
        setIsTeamsPage(true);
        setIsHomePage(true);
        setIsCollectAboutPage(false);
        setIsCollectMembersPage(false);
        setIsGameChatPage(false);
      }
    }
    return () => {
      isMounted = false;
    };
  }, [entity?.id, currentUser?.id]);

  //Outside click to close
  const menuRefs = useRef<HTMLDivElement | null>(null);
  useOutsideAlerter(menuRefs);
  function useOutsideAlerter(ref) {
    useEffect(() => {
      console.log("useEffect12");
      let isMounted = true;
      if (isMounted) {
        function handleClickOutside(event) {
          if (ref.current && !ref.current.contains(event.target)) {
            setOrgOpen(false);
            setIsActives(false);
            setOrgOpen(false);
            setIsOpen(false);
            setIsShowEditOccurence(false);
            setIsShowEditEntireSeries(false);
            setIsSchoolYearsOrgTabOption(false);
          }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }
      return () => {
        isMounted = false; // Set the flag to false when the component is unmounted
        // Cancel subscriptions or perform any cleanup tasks here
      };
    }, [ref]);
  }

  return (
    <>
      <AVBody
        setShowCreateNewPage={setShowCreateNewPage}
        isOpenConvo={isOpenConvo}
        setIsOpenConvo={setIsOpenConvo}
        setIsShowEdit={setIsShowEdit}
        showCreateNewPage={showCreateNewPage}
        setCreateType={setCreateType}
        createType={createType}
        passEntity={passEntity}
        setPassEntity={setPassEntity}
        leagueGameEntity={leagueGameEntity}
        setIsConvoData={setIsConvoData}
        isConvoData={isConvoData}
        setIshuddleData={setIsHuddleData}
      >
        {pageLoader && !isCreate && (entity == undefined || entity == null) ? (
          <PageLoader />
        ) : (
          <>
            <HStack flex={1} width={"100%"} space={[0, 0, 3, 4]}>
              <HStack flex={[1, 1, 3]}>
                <VStack flex={1}>
                  <Box
                    height={"auto"}
                    borderRadius={5}
                    backgroundColor={"AVColor.white"}
                    shadow={1}
                    borderTopLeftRadius={10}
                    borderTopRightRadius={10}
                    marginBottom={"12px"}
                  >
                    {/*ProfileHeader*/}
                    <ProfileHeader
                      props={props}
                      setIshuddleData={setIsHuddleData}
                      isCreate={isCreate}
                      setIsCreateDependents={undefined}
                      isCreateDependents={undefined}
                      isShowEdit={isShowEdit}
                      Entity={entity}
                      setPassEntity={setPassEntity}
                      leagueGameEntity={leagueGameEntity}
                      setLeagueGameEntity={setLeagueGameEntity}
                      handleUpload={handleUpload}
                      EntityType={viewTeam ? viewTeam : entity}
                      type={feedBackType}
                      setIsShowEdit={setIsShowEdit}
                      profile={profile}
                      setProfile={setProfile}
                      googlemap={googleMap}
                      isAdminView={isAdminView}
                      setIsAdminView={setIsAdminView}
                      weatherURL={undefined}
                      weather={undefined}
                      Owner={owner}
                      setIsImagePopup={setIsImagePopup}
                      setEntity={setEntity}
                      editAccess={isOngoingOrFuture}
                      isEntireSeriesAvailable={isEntireSeriesAvailable}
                      setIsStaffReq={setIsStaffReq}
                      setIsChildOrgReq={setIsChildOrgReq}
                      isDeleted={isDeleted}
                      HandleBlockUser={undefined}
                      setIsConvoData={setIsConvoData}
                      HandleUnBlockUser={undefined}
                      HandleRestoreAccount={HandleRestoreAccount}
                      HandleUnFollowUser={undefined}
                      setIsOpenConvo={setIsOpenConvo}
                      setIsEditEntireSeries={setIsEditEntireSeries}
                      isEditEntireSeries={isEditEntireSeries}
                      seriesEvent={seriesEvent}
                      isRequestAgain={false}
                      setIsRequestAgain={undefined}
                      openPreview={openPreviewprofile}
                      isShowPayPopup={isShowPayPopup}
                      setIsShowPayPopup={setIsShowPayPopup}
                      setClickedUrl={setClickedUrl}
                      setShowConfirmLinkPopup={setShowConfirmLinkPopup}
                      eventSeriesId={params?.seriesId}
                      isOngoingOrFuture={
                        isOngoingOrFuture || isEntireSeriesAvailable
                      }
                      //isShowAddGuestTeam={isShowAddGuestTeam}
                      //setIsShowAddGuestTeam={setIsShowAddGuestTeam}
                      //guestTeamName={guestTeamName}
                      //setGuestTeamName={setGuestTeamName}
                      //guestTeamLocation={guestTeamLocation}
                      //setGuestTeamLocation={setGuestTeamLocation}
                    />

                    {/*Create and Edit All entity*/}
                    {(isCreate || isShowEdit) && (
                      <AVCreateTeam
                        isCreate={isCreate}
                        setIsCreate={setIsCreate}
                        type={
                          location?.state?.type
                            ? location?.state?.type
                            : entity?.type
                        }
                        profile={profile}
                        isShowEdit={isShowEdit}
                        setIsShowEdit={setIsShowEdit}
                        teamType={teamType}
                        Entity={entity}
                        setEntity={setEntity}
                        EntityDataFinding={EntityDataFinding}
                        setgooglemap={setGoogleMap}
                        setProfile={setProfile}
                        handleUpload={handleUpload}
                        setShowCreateNewPage={setShowCreateNewPage}
                        setCreateType={setCreateType}
                        setPassEntity={setPassEntity}
                        passEntity={passEntity}
                        isEditEntireSeries={isEditEntireSeries}
                        setIsEditEntireSeries={setIsEditEntireSeries}
                        seriesEvent={currentItem}
                        softLinkId={location?.state?.softLinkId ?? null}
                        inviteToken={location?.state?.inviteToken ?? ""}
                        leagueInviteFK={location?.state?.team}
                      />
                    )}

                    {/* TabHeader and feedback*/}
                    {!isCreate && !isShowEdit && isDeleted && (
                      <HStack
                        height={
                          feedBackType === "Feedback" &&
                          feedBackId === "78b5b063-fd3e-4925-92bd-2a1888c6a46a"
                            ? "auto"
                            : feedBackId ===
                                "b495d4e0-bf52-4690-8dc0-677db954aa72"
                              ? "0px"
                              : "61px"
                        }
                        width={"100%"}
                      >
                        {feedBackType !== "Feedback" && (
                          <TabHeader
                            menu={menuTabs}
                            MoreMenu={menuTabs}
                            isDropDown={isDropDown}
                            Entity={entity}
                            setIsDropDown={setIsDropDown}
                            type={entity?.type ?? undefined}
                            userLang={currentUser?.preferences?.lang}
                            onboardingFlow={onboardingFlow}
                            onboardingStep={onboardingStep}
                            setOnboardingStep={setOnboardingStep}
                            clearCurrentTourFlow={clearCurrentTourFlow}
                          />
                        )}

                        {feedBackType === "Feedback" && (
                          <VStack
                            paddingY={"24px"}
                            paddingLeft={"24px"}
                            paddingRight={"12px"}
                            width={"100%"}
                          >
                            {feedBackType === "Feedback" &&
                              feedBackId ===
                                "78b5b063-fd3e-4925-92bd-2a1888c6a46a" && (
                                <HStack marginBottom={"24px"}>
                                  <Text fontSize={"16px"} fontWeight={400}>
                                    {
                                      Loc.currentLang.menu
                                        .toStartAPostPleaseSelectACategory
                                    }
                                  </Text>
                                </HStack>
                              )}

                            {feedBackType === "Feedback" &&
                              (feedBackId ===
                                "b495d4e0-bf52-4690-8dc0-677db954aa7f" ||
                                feedBackId ===
                                  "b495d4e0-bf52-4690-8dc0-677db954aa7f") && (
                                <HStack marginBottom={"24px"} space={4}>
                                  <Text fontSize={"16px"} fontWeight={400}>
                                    {
                                      Loc.currentLang.menu
                                        .shareYourFeedbackLetUsKnowWhatIsGoingOnYourMind
                                    }
                                  </Text>
                                </HStack>
                              )}

                            {feedBackType === "Feedback" &&
                              (feedBackId ===
                                "b495d4e0-bf52-4690-8dc0-677db954aa71" ||
                                feedBackId ===
                                  "b495d4e0-bf52-4690-8dc0-677db954aa71") && (
                                <HStack marginBottom={"24px"}>
                                  <Text fontSize={"16px"} fontWeight={400}>
                                    {
                                      Loc.currentLang.menu
                                        .shareYourFeedbackLetUsKnowWhatIsGoingOnYourMind
                                    }
                                  </Text>
                                </HStack>
                              )}

                            {type === "Feedback" &&
                              (feedBackId ===
                                "b495d4e0-bf52-4690-8dc0-677db954aa72" ||
                                feedBackId ===
                                  "b495d4e0-bf52-4690-8dc0-677db954aa72") && (
                                <HStack marginBottom={"24px"}>
                                  <Text fontSize={"16px"} fontWeight={400}>
                                    {
                                      Loc.currentLang.menu
                                        .shareYourFeedbackLetUsKnowWhatIsGoingOnYourMind
                                    }
                                  </Text>
                                </HStack>
                              )}

                            {feedBackId !==
                              "b495d4e0-bf52-4690-8dc0-677db954aa72" &&
                              feedBackId !==
                                "b495d4e0-bf52-4690-8dc0-677db954aa71" &&
                              feedBackId !==
                                "b495d4e0-bf52-4690-8dc0-677db954aa7f" && (
                                <HStack
                                  flexWrap={"wrap"}
                                  zIndex={-2}
                                  alignSelf={"center"}
                                  space={"24px"}
                                >
                                  {isShowTeamsList?.length > 0 &&
                                    isShowTeamsList?.map((item, i) => (
                                      <Box
                                        key={item.id ?? i}
                                        bgColor={"#fff"}
                                        borderWidth={"1px"}
                                        borderColor={"gray.100"}
                                        shadow={3}
                                        width={"235px"}
                                        marginY={"5px"}
                                        height={"208px"}
                                        borderRadius={8}
                                      >
                                        <VStack
                                          key={item?.id}
                                          alignItems={"center"}
                                          padding={2}
                                          height={"100%"}
                                          width={"100%"}
                                        >
                                          <Pressable
                                            key={item.id}
                                            _hover={{ bgColor: "gray.100" }}
                                            p={2}
                                            height={"100%"}
                                            alignItems={"center"}
                                            width={"100%"}
                                            borderRadius={5}
                                            minWidth={120}
                                            onPress={() =>
                                              HandeFeedBackNavigate(item)
                                            }
                                          >
                                            {item?.thumb && (
                                              <Box
                                                bgColor={"#FF6600"}
                                                borderRadius={["full"]}
                                                width={"100px"}
                                                height={"100px"}
                                                alignSelf={"center"}
                                              >
                                                <Image
                                                  source={{
                                                    uri: AV.Media.getThumb(
                                                      item,
                                                    ),
                                                  }}
                                                  borderRadius={["full"]}
                                                  width={"100%"}
                                                  height={["100%"]}
                                                  alt="Image"
                                                />
                                              </Box>
                                            )}
                                            {item?.title === "Feedback" && (
                                              <FeedbackIcon
                                                height={"100"}
                                                width={"100"}
                                              />
                                            )}
                                            {item?.title === "Bug Reports" && (
                                              <BugReportIcon
                                                height={"100"}
                                                width={"100"}
                                              />
                                            )}
                                            {item?.title ===
                                              "Feature Requests" && (
                                              <FeatureRequestIcon
                                                height={"100"}
                                                width={"100"}
                                              />
                                            )}
                                            <Tooltip
                                              label={item?.title ?? ""}
                                              openDelay={500}
                                            >
                                              <Pressable
                                                paddingTop={"24px"}
                                                onPress={() =>
                                                  HandeFeedBackNavigate(item)
                                                }
                                              >
                                                <Text
                                                  numberOfLines={1}
                                                  alignSelf={"center"}
                                                  fontWeight={500}
                                                >
                                                  {item?.title === "Feedback"
                                                    ? Loc.currentLang.menu
                                                        .feedback
                                                    : item?.title ===
                                                        "Bug Reports"
                                                      ? Loc.currentLang.menu
                                                          .bugReports
                                                      : item?.title ===
                                                          "Feature Requests"
                                                        ? Loc.currentLang.menu
                                                            .featureRequests
                                                        : item?.title}
                                                </Text>
                                              </Pressable>
                                            </Tooltip>
                                          </Pressable>
                                        </VStack>
                                      </Box>
                                    ))}
                                </HStack>
                              )}
                          </VStack>
                        )}
                      </HStack>
                    )}
                  </Box>

                  {/*Suspended POPUP*/}
                  {entity?.status === "Suspended" &&
                    !isSuspended &&
                    !isAdminView &&
                    !isCreate &&
                    !isShowEdit && (
                      <Box
                        position={"fixed"}
                        top={0}
                        bottom={0}
                        left={0}
                        right={0}
                        display={"flex"}
                        alignItems={"center"}
                        justifyContent={"center"}
                        backgroundColor={"rgba(0, 0, 0, 0.25)"}
                        zIndex={9999}
                      >
                        <div className={`customModal`}>
                          <div className={`show_unauthorized_details`}>
                            <VStack alignItems={"center"} width={"100%"}>
                              <HStack
                                position={"absolute"}
                                justifyContent={"flex-end"}
                                right={"15px"}
                                top={"13px"}
                                width={"100%"}
                              >
                                <AVCancel
                                  color={undefined}
                                  size={undefined}
                                  callback={() => setIsSuspended(true)}
                                />
                              </HStack>

                              <img
                                src={suspend}
                                alt="image"
                                height={"220px"}
                                width={"240px"}
                              />

                              <HStack paddingBottom={"8px"}>
                                <Text fontWeight={400} fontSize={"24px"}>
                                  {Loc.currentLang.menu.temporaryTakingaBreak}
                                </Text>
                              </HStack>

                              <HStack>
                                <Text>
                                  {Loc.currentLang.menu.restrictPostTxt}
                                </Text>
                              </HStack>

                              <HStack marginTop={"15px"}>
                                <Button
                                  rounded="full"
                                  backgroundColor={"#EEEEEE"}
                                  height={"30px"}
                                  width={"60px"}
                                  onPress={() => setIsSuspended(true)}
                                >
                                  <Text
                                    fontSize={"14px"}
                                    color={"rgba(0,0,0,0.5)"}
                                    fontWeight={"bold"}
                                  >
                                    {Loc.currentLang.menu.ok}
                                  </Text>
                                </Button>
                              </HStack>
                            </VStack>
                          </div>
                        </div>
                      </Box>
                    )}

                  <VStack zIndex={isDropDown || isShowPayPopup ? -3 : ""}>
                    {/* Event page*/}
                    {isEventPage && !isShowEdit && (
                      <AVCardList
                        tab={"Events"}
                        isAdminView={isAdminView}
                        isCreate={isCreate}
                        setIsCreate={setIsCreate}
                        entity={entity!}
                        setEntity={setEntity}
                        menuRefs={menuRefs}
                        allEventData={allEventData}
                        isLoadingEvent={isLoadingEvent}
                        isCalendarView={isCalendarView}
                        setIsCalenderView={setIsCalenderView}
                        handleCreateEvent={handleCreateEvent}
                      />
                    )}

                    {/* season page*/}
                    {isSeasonPage && !isShowEdit && (
                      <AVCardList
                        tab={"Season"}
                        isAdminView={isAdminView}
                        isCreate={isCreate}
                        setIsCreate={setIsCreate}
                        entity={entity!}
                        setEntity={setEntity}
                        onboardingFlow={onboardingFlow}
                        onboardingStep={onboardingStep}
                        setOnboardingStep={setOnboardingStep}
                        clearCurrentTourFlow={clearCurrentTourFlow}
                      />
                    )}

                    {/* staff page*/}
                    {isStaffPage && !isShowEdit && (
                      <>
                        <Box
                          width={"100%"}
                          minHeight={"340px"}
                          h="auto"
                          paddingTop={"10px"}
                          bgColor="#fff"
                          rounded="lg"
                        >
                          <VStack zIndex={-3}>
                            <HStack
                              alignItems={"center"}
                              justifyContent={"space-between"}
                            >
                              <Text
                                fontWeight={"500"}
                                marginLeft={"15px"}
                                fontSize={"22px"}
                                color={"AVColor.primary"}
                                py={"12px"}
                              >
                                {entity?.type === "School"
                                  ? Loc.currentLang.menu.administration
                                  : (entity as AV.IOrgBase)?.subType === "Term"
                                    ? "Directors"
                                    : Loc.currentLang.menu.staff}
                              </Text>

                              <HStack alignItems={"center"} zIndex={-3}>
                                <Tooltip
                                  label={helpText}
                                  w={200}
                                  openDelay={500}
                                >
                                  <Box
                                    marginRight={"10px"}
                                    p={"9px"}
                                    shadow={1}
                                    zIndex={-3}
                                    backgroundColor={"AVColor.liteBg"}
                                    rounded={"full"}
                                  >
                                    <img
                                      src={helping}
                                      height={"17px"}
                                      width={"17px"}
                                      style={{ zIndex: -3 }}
                                    />
                                  </Box>
                                </Tooltip>
                                {isAdminView && (
                                  <Tooltip
                                    label={Loc.currentLang.menu.editRoles}
                                    openDelay={500}
                                  >
                                    <Pressable
                                      backgroundColor={"AVColor.liteBg"}
                                      rounded={"full"}
                                      p={"10px"}
                                      marginRight={"10px"}
                                      _hover={{
                                        backgroundColor: "AVColor.hovercolor",
                                      }}
                                      onPress={() => {
                                        navigate(
                                          `/accountsettings/${entity?.id}/${entity?.region}`,
                                          {
                                            state: {
                                              page: pathName,
                                              Entity: entity,
                                              isEdit: true,
                                            },
                                          },
                                        );
                                      }}
                                    >
                                      <EditIcon size="20px" />
                                    </Pressable>
                                  </Tooltip>
                                )}

                                {staffList?.length > 0 && (
                                  <Button
                                    isDisabled={!isOnline}
                                    p={"10px"}
                                    shadow={1}
                                    bgColor={isLoad ? "#32AE78" : "gray.100"}
                                    _hover={{ bgColor: "gray.50" }}
                                    isLoading={isLoad}
                                    rounded={"full"}
                                    marginRight={"3px"}
                                    onPress={() => HandleGroupChat("S")}
                                  >
                                    {
                                      <GroupChatIcon
                                        size={23}
                                        color={"rgba(0, 0, 0, 0.5)"}
                                      />
                                    }
                                  </Button>
                                )}

                                {isAdminView && (
                                  <Button
                                    isDisabled={!isOnline}
                                    p={"10px"}
                                    shadow={1}
                                    bgColor={"gray.100"}
                                    _hover={{ bgColor: "gray.50" }}
                                    rounded={"full"}
                                    marginRight={"3px"}
                                    onPress={() => handleProfileType("Staff")}
                                  >
                                    <AddIcon size={"20px"} color={"#32AE78"} />
                                  </Button>
                                )}
                              </HStack>
                            </HStack>
                          </VStack>
                          <Divider my={2} zIndex={-3} />

                          <HStack flexWrap={"wrap"} width={"100%"}>
                            <FlatList
                              width={"100%"}
                              data={staffList}
                              scrollEnabled={true}
                              ListEmptyComponent={
                                <Center height={200}>
                                  {Loc.currentLang.menu.noStaffsFound}
                                </Center>
                              }
                              renderItem={(item: any) => (
                                <StaffsCard
                                  entity={entity}
                                  data={item}
                                  {...props}
                                  key={item?.id}
                                  item={item}
                                  setStaffList={setStaffList}
                                  editStaffItem={editStaffItem}
                                  setEditStaffItem={setEditStaffItem}
                                  staffList={staffList}
                                  setIsStaffEdit={setIsStaffEdit}
                                  setStaffEmail={setStaffEmail}
                                  setStaffPhone={setStaffPhone}
                                  setStaffRole={setStaffRole}
                                  setStaffPic={setStaffPic}
                                  HandleRemoveStaffs={HandleRemoveStaffs}
                                  setIsOpenConvo={setIsOpenConvo}
                                  setIsConvoData={setIsConvoData}
                                />
                              )}
                              showsVerticalScrollIndicator={false}
                              numColumns={isMobile ? 1 : isTab ? 2 : 3}
                            />
                          </HStack>
                        </Box>

                        {isStaffEdit && (
                          <Box
                            position="fixed"
                            bgColor={"AVColor.overlay2"}
                            bottom={0}
                            right={0}
                            top={0}
                            left={0}
                            zIndex={99}
                          >
                            <div
                              style={{
                                position: "fixed",
                                top: "58%",
                                left: "53%",
                                width: "90%",
                                transform: "translate(-53%, -50%)",
                                background: "#ffffff",
                                boxShadow:
                                  "0 12px 28px 0 rgba(0, 0, 0, 0.2), 0 2px 4px 0 rgba(0, 0, 0, 0.1), inset 0 0 0 1px rgba(255, 255, 255, 0.5)",
                                minWidth: isMobile
                                  ? "320px"
                                  : isLMobile
                                    ? "480px"
                                    : "600px",
                                maxWidth: "1000px",
                                borderRadius: "8px",
                                minHeight: "300px",
                              }}
                            >
                              <VStack
                                flex={1}
                                minHeight={isMobile ? "600px" : "450px"}
                                maxHeight={"625px"}
                              >
                                <HStack
                                  alignItems={"center"}
                                  justifyContent={"space-between"}
                                  borderBottomColor={"AVColor.grey"}
                                  px={5}
                                  zIndex={99}
                                  marginTop={"10px"}
                                >
                                  <Text fontSize={24}>
                                    {Loc.currentLang.menu.editStaffMember}
                                  </Text>
                                  <HStack justifyContent={"flex-end"}>
                                    <AVCancel
                                      color={undefined}
                                      size={undefined}
                                      callback={() => setIsStaffEdit(false)}
                                    />
                                  </HStack>
                                </HStack>
                                <Pressable zIndex={-3}>
                                  <Box p={1} borderRadius={"full"}>
                                    <HStack space={2} px={2}>
                                      {editStaffItem?.thumb ||
                                      editStaffItem?.linkPic ? (
                                        <Box
                                          bgColor={"#FF6600"}
                                          borderRadius={["full"]}
                                          width={"70px"}
                                          height={"70px"}
                                          left={"1px"}
                                          p={0}
                                        >
                                          <Image
                                            source={{
                                              uri: editStaffItem?.linkPic
                                                ? AV.Media.getURL(
                                                    editStaffItem?.linkPic,
                                                  )
                                                : AV.Media.getThumb(
                                                    editStaffItem,
                                                  ),
                                            }}
                                            borderRadius={["full"]}
                                            alt="Image"
                                            width={"100%"}
                                            height={["100%"]}
                                          />
                                          <Button
                                            bgColor={"AVColor.white"}
                                            position={"absolute"}
                                            top={"45px"}
                                            right={"-6px"}
                                            p={0}
                                            rounded={"full"}
                                            _hover={{
                                              backgroundColor:
                                                "AVColor.hovercolor",
                                            }}
                                            shadow={1}
                                            zIndex={99}
                                            isLoading={isPicLoader}
                                            _spinner={{
                                              color: "AVColor.black",
                                            }}
                                          >
                                            <Box
                                              {...getStaffProfilePicFile({
                                                className: "dropzone",
                                              })}
                                            >
                                              <input
                                                {...getStaffProfileInputProps()}
                                              />
                                              <AddPhotoIcon size={18} p={1} />
                                            </Box>
                                          </Button>
                                        </Box>
                                      ) : (
                                        <Box alignItems={"center"}>
                                          <Profile
                                            height={"70"}
                                            width={"70"}
                                            color={"#32AE78"}
                                          />

                                          <Button
                                            bgColor={"AVColor.white"}
                                            position={"absolute"}
                                            top={"45px"}
                                            right={"-6px"}
                                            p={0}
                                            rounded={"full"}
                                            _hover={{
                                              backgroundColor:
                                                "AVColor.hovercolor",
                                            }}
                                            shadow={1}
                                            zIndex={99}
                                            isLoading={isPicLoader}
                                            _spinner={{
                                              color: "AVColor.black",
                                            }}
                                          >
                                            <Box
                                              {...getStaffProfilePicFile({
                                                className: "dropzone",
                                              })}
                                            >
                                              <input
                                                {...getStaffProfileInputProps()}
                                              />
                                              <AddPhotoIcon size={18} p={1} />
                                            </Box>
                                          </Button>
                                        </Box>
                                      )}
                                      <Text
                                        marginTop={"20px"}
                                        left={"2px"}
                                        marginLeft={"35px"}
                                        alignItems="center"
                                        width="300px"
                                        numberOfLines={1}
                                        textAlign="center"
                                        zIndex={-3}
                                        fontSize={24}
                                      >
                                        {editStaffItem?.title}
                                      </Text>
                                    </HStack>
                                  </Box>
                                </Pressable>
                                <HStack
                                  alignItems={"center"}
                                  display={"block"}
                                  borderBottomColor={"AVColor.grey"}
                                  px={5}
                                  py={5}
                                  zIndex={99}
                                >
                                  <VStack marginTop={"15px"}>
                                    <FormControl fullWidth>
                                      <InputLabel id="demo-simple-select-label">
                                        {Loc.currentLang.menu.assignRoleReq}
                                      </InputLabel>
                                      <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={staffRole}
                                        label={
                                          Loc.currentLang.menu.assignRoleReq
                                        }
                                        onChange={handleStaffRole}
                                      >
                                        {(entity as AV.IOrgBase)?.roles?.map(
                                          (option) => (
                                            <MenuItem
                                              key={option?.name}
                                              value={option?.name}
                                            >
                                              {option?.name}
                                            </MenuItem>
                                          ),
                                        )}
                                      </Select>
                                    </FormControl>
                                  </VStack>
                                  <VStack marginTop={"15px"}>
                                    <AVInputtext
                                      type={"text"}
                                      onChange={(e) =>
                                        setStaffPhone(
                                          e.target.value.replace(/[^0-9]/g, ""),
                                        )
                                      }
                                      value={staffPhone}
                                      label={Loc.currentLang.menu.phone}
                                      height={"15px"}
                                      width={isMobile ? "245px" : "200px"}
                                      maxLength={50}
                                      defaultValue={undefined}
                                      minRows={undefined}
                                      multiline={undefined}
                                      placeholder={undefined}
                                      size={undefined}
                                    />
                                  </VStack>
                                  <VStack marginTop={"15px"}>
                                    <AVInputtext
                                      type={"text"}
                                      onChange={(e) =>
                                        setStaffEmail(e.target.value)
                                      }
                                      value={staffEmail}
                                      label={
                                        Loc.currentLang.menu.emailAddressNotReq
                                      }
                                      height={"15px"}
                                      width={isMobile ? "245px" : "200px"}
                                      maxLength={50}
                                      defaultValue={undefined}
                                      minRows={undefined}
                                      multiline={undefined}
                                      placeholder={undefined}
                                      size={undefined}
                                    />
                                  </VStack>
                                </HStack>
                                <HStack
                                  width={"100%"}
                                  height="100%"
                                  space={5}
                                  flex={1}
                                  justifyContent={"center"}
                                  px={5}
                                  m={3}
                                  zIndex={-1}
                                >
                                  <Button
                                    rounded="full"
                                    backgroundColor={"#EEEEEE"}
                                    paddingX={"20px"}
                                    width={isMobile ? "40%" : "24%"}
                                    height={"40px"}
                                    onPress={() => {
                                      setIsStaffEdit(false);
                                    }}
                                  >
                                    <Text
                                      fontSize={"14px"}
                                      color={"rgba(0,0,0,0.5)"}
                                      fontWeight={"bold"}
                                    >
                                      {Loc.currentLang.menu.cancel}
                                    </Text>
                                  </Button>
                                  <Button
                                    rounded="full"
                                    backgroundColor={"#32AE78"}
                                    paddingX={"20px"}
                                    onPress={() => {
                                      handleEditStaff(editStaffItem);
                                    }}
                                    isLoading={isLoading}
                                    isLoadingText={
                                      Loc.currentLang.menu.saveLoad
                                    }
                                    width={isMobile ? "40%" : "24%"}
                                    height={"40px"}
                                  >
                                    <Text fontSize={"14px"} color={"white"}>
                                      {Loc.currentLang.menu.save}
                                    </Text>
                                  </Button>
                                </HStack>
                                {error && (
                                  <HStack
                                    justifyContent={"center"}
                                    marginBottom={"10px"}
                                  >
                                    <Text color={"red.500"} fontWeight={400}>
                                      {error}
                                    </Text>
                                  </HStack>
                                )}
                              </VStack>
                            </div>
                          </Box>
                        )}
                      </>

                      //<AVCardList
                      //  tab={"Staff"}
                      //  isAdminView={isAdminView}
                      //  isCreate={isCreate}
                      //  setIsCreate={setIsCreate}
                      //  entity={entity!}
                      //  setEntity={setEntity}
                      //  handleChat={handleChat}
                      //  createConvoKey={"S"}
                      //  handleGroupChat={HandleGroupChat}
                      //  handleRemoveGroup={HandleRemoveStaffs}
                      //  handleProfileType={handleProfileType}
                      ///>
                    )}

                    {/* huddles Page*/}
                    {isHuddlePage && !isShowEdit && (
                      <AVCardList
                        tab={"Huddles"}
                        isAdminView={isAdminView}
                        isCreate={isCreate}
                        setIsCreate={setIsCreate}
                        entity={entity!}
                        setEntity={setEntity}
                      />
                    )}

                    {/* player page*/}
                    {isPlayerPage && !isShowEdit && (
                      <Box
                        width={"100%"}
                        minHeight={"340px"}
                        marginRight={4}
                        p={2}
                        h="auto"
                        shadow={1}
                        bgColor="#fff"
                        rounded="lg"
                      >
                        <VStack>
                          <HStack
                            alignItems={"center"}
                            justifyContent={"space-between"}
                          >
                            <Text
                              fontWeight={"500"}
                              marginLeft={"15px"}
                              fontSize={"22px"}
                              color={"AVColor.primary"}
                              py={"12px"}
                            >
                              {(entity as AV.IOrgBase)?.subType === "Class" ||
                              (entity as AV.IOrgBase)?.subType ===
                                "GradClass" ||
                              (entity as AV.IOrgBase)?.type === "SchoolYear"
                                ? Loc.currentLang.menu.students
                                : (entity as AV.IOrgBase)?.subType === "Term"
                                  ? Loc.currentLang.menu.members
                                  : Loc.currentLang.menu.players}
                            </Text>

                            <HStack alignItems="center" space="10px">
                              {playersList?.length > 0 && (
                                <Tooltip
                                  label={helpText}
                                  w={200}
                                  openDelay={100}
                                >
                                  <Box
                                    rounded="full"
                                    bg="gray.100"
                                    shadow={1}
                                    p="10px"
                                    minW="40px"
                                    h="40px"
                                  >
                                    <img
                                      src={helping}
                                      height="20px"
                                      width="20px"
                                    />
                                  </Box>
                                </Tooltip>
                              )}

                              {!(
                                entity?.type === "SchoolYear" && isAdminView
                              ) &&
                                playersList?.length > 0 && (
                                  <Button
                                    isDisabled={!isOnline}
                                    rounded="full"
                                    bg={isLoad ? "#32AE78" : "gray.100"}
                                    _hover={{ bg: "AVColor.hovercolor" }}
                                    shadow={1}
                                    p="10px"
                                    minW="40px"
                                    h="40px"
                                    isLoading={isLoad}
                                    onPress={() => HandleGroupChat("P")}
                                  >
                                    <GroupChatIcon
                                      size={23}
                                      color="rgba(0,0,0,0.6)"
                                    />
                                  </Button>
                                )}

                              {isAdminView && (
                                <div ref={addPlayerBtnRef}>
                                  <Button
                                    isDisabled={!isOnline}
                                    rounded="full"
                                    bg="gray.100"
                                    _hover={{ bg: "AVColor.hovercolor" }}
                                    shadow={1}
                                    p="10px"
                                    minW="40px"
                                    h="40px"
                                    onPress={() => handleProfileType("Player")}
                                  >
                                    <AddIcon size="20px" color="#32AE78" />
                                  </Button>
                                </div>
                              )}
                            </HStack>
                          </HStack>
                        </VStack>
                        <Divider my={2} zIndex={-3} />

                        <HStack>
                          <FlatList
                            height={dimensions.height - 110}
                            width={"100%"}
                            data={playersList}
                            scrollEnabled={true}
                            ListEmptyComponent={
                              <HStack
                                width={"100%"}
                                top={isMobile ? "20px" : "0px"}
                                padding={isMobile ? "10px" : "10px"}
                                marginTop={isMobile ? "-10px" : "0px"}
                                space={isMobile ? 2 : 2}
                              >
                                <img
                                  src={inform}
                                  style={{
                                    width: "20px",
                                    height: "20px",
                                  }}
                                />
                                <Text
                                  fontSize={"16px"}
                                  fontWeight="400"
                                  numberOfLines={4}
                                  ellipsizeMode={"tail"}
                                >
                                  {helpText}
                                </Text>
                              </HStack>
                            }
                            renderItem={(item: any) => (
                              <PlayersCard
                                leagueTeam={entity}
                                data={item}
                                {...props}
                                key={item.id}
                                item={item}
                                playersList={playersList}
                                setPlayersList={setPlayersList}
                                HandleRemoveplayers={HandleRemoveplayers}
                                isRotate={isRotate}
                                handleChat={handleChat}
                                isMemberTab={isMemberTab}
                                isAdminView={isAdminView}
                                handleConfirmToggleSilence={
                                  handleConfirmToggleSilence
                                }
                              />
                            )}
                            showsVerticalScrollIndicator={false}
                            numColumns={3}
                          />
                        </HStack>
                      </Box>
                    )}

                    {/* chat page*/}
                    {isGameChatPage &&
                      isAdminView &&
                      ((entity?.type === "LeagueGameBase" &&
                        entity?.status !== "Ended") ||
                        ((leagueGameEntity?.parent?.type === "Game" ||
                          leagueGameEntity?.parent?.type === "LeagueSeason") &&
                          leagueGameEntity?.status !== "Ended")) && (
                        <AVChatMessage
                          page={"tab"}
                          props={props}
                          entity={entity!}
                          setEntity={setEntity}
                          isAdminView={isAdminView}
                          setIsAdminView={setIsAdminView}
                          leagueGameEntity={leagueGameEntity}
                          setLeagueGameEntity={setLeagueGameEntity}
                        />
                      )}

                    {/* participant page*/}
                    {isParticipantsPage && !isShowEdit && (
                      //|| isOngoingOrFuture || isEntireSeriesAvailable
                      <AVCardList
                        tab={"Participants"}
                        isAdminView={isAdminView}
                        isCreate={isCreate}
                        setIsCreate={setIsCreate}
                        entity={entity!}
                        setEntity={setEntity}
                        menuRefs={menuRefs}
                        handleChat={handleChat}
                        createConvoKey={"N"}
                        handleGroupChat={HandleGroupChat}
                        handleProfileType={handleProfileType}
                        eventSeriesId={params?.seriesId}
                        isOngoingOrFuture={isOngoingOrFuture}
                        setIsOngoingOrFuture={setIsOngoingOrFuture}
                        isShowEditOccurence={isShowEditOccurence}
                        setIsShowEditOccurence={setIsShowEditOccurence}
                        isShowEditEntireSeries={isShowEditEntireSeries}
                        setIsShowEditEntireSeries={setIsShowEditEntireSeries}
                        isEditEntireSeries={isEditEntireSeries}
                        setIsEditEntireSeries={setIsEditEntireSeries}
                        isEntireSeriesAvailable={isEntireSeriesAvailable}
                        setIsEntireSeriesAvailable={setIsEntireSeriesAvailable}
                        handleRemoveGroup={HandleRemoveParticipant}
                        checkConvoExitorNot={checkConvoExitorNot}
                      />
                    )}

                    {/* resource page*/}
                    {isResourses && !isShowEdit && (
                      //|| isOngoingOrFuture || isEntireSeriesAvailable
                      <AVCardList
                        tab={"Resources"}
                        isAdminView={isAdminView}
                        isCreate={isCreate}
                        setIsCreate={setIsCreate}
                        entity={entity!}
                        setEntity={setEntity}
                        menuRefs={menuRefs}
                        eventSeriesId={params?.seriesId}
                        isOngoingOrFuture={isOngoingOrFuture}
                        setIsOngoingOrFuture={setIsOngoingOrFuture}
                        isShowEditOccurence={isShowEditOccurence}
                        setIsShowEditOccurence={setIsShowEditOccurence}
                        isShowEditEntireSeries={isShowEditEntireSeries}
                        setIsShowEditEntireSeries={setIsShowEditEntireSeries}
                        isEditEntireSeries={isEditEntireSeries}
                        setIsEditEntireSeries={setIsEditEntireSeries}
                        isEntireSeriesAvailable={isEntireSeriesAvailable}
                        setIsEntireSeriesAvailable={setIsEntireSeriesAvailable}
                        handleRemoveGroup={handleRemoveResourcePopup}
                      />
                    )}

                    {/* group page*/}
                    {isGroup && !isShowEdit && (
                      <>
                        <Box
                          minHeight={"340px"}
                          borderRadius={5}
                          backgroundColor={"AVColor.white"}
                          shadow={1}
                          flex={1}
                          mb={3}
                        >
                          <VStack>
                            <HStack
                              alignItems={"center"}
                              justifyContent={"space-between"}
                            >
                              <Text
                                fontWeight={"500"}
                                marginLeft={"15px"}
                                fontSize={"22px"}
                                color={"AVColor.primary"}
                                py={"12px"}
                              >
                                {Loc.currentLang.menu.organization}
                              </Text>

                              <HStack alignItems={"center"} pr={2}>
                                <HStack space={3}>
                                  <Tooltip
                                    label={helpText}
                                    w={200}
                                    openDelay={500}
                                  >
                                    <Box
                                      marginTop={"5px"}
                                      height={"36px"}
                                      marginRight={"10px"}
                                      p={"9px"}
                                      display={
                                        groupList?.length > 0 ? "" : "none"
                                      }
                                      shadow={1}
                                      backgroundColor={"AVColor.liteBg"}
                                      rounded={"full"}
                                    >
                                      <img
                                        src={helping}
                                        height={"17px"}
                                        width={"17px"}
                                      />
                                    </Box>
                                  </Tooltip>

                                  {isAdminView ? (
                                    (entity as AV.IOrgBase)?.subType ===
                                      "Department" ||
                                    (entity as AV.IOrgBase)?.subType ===
                                      "GradClass" ? (
                                      <AVComDropdonwn
                                        dropdownValues={
                                          (entity as AV.IOrgBase)?.subType ===
                                          "Department"
                                            ? dropdownSchlDeptValues
                                            : dropdownComEventValues
                                        }
                                      />
                                    ) : (
                                      <Button
                                        isDisabled={!isOnline}
                                        p={"10px"}
                                        shadow={1}
                                        bgColor={"gray.100"}
                                        _hover={{ bgColor: "gray.50" }}
                                        rounded={"full"}
                                        marginRight={"3px"}
                                        onPress={() => HandleCreateGroup()}
                                      >
                                        <AddIcon
                                          size={"20px"}
                                          color={"#32AE78"}
                                        />
                                      </Button>
                                    )
                                  ) : null}

                                  {isAdminView && (
                                    <VStack
                                      height={"40px"}
                                      width={"40px"}
                                      ref={menuRefs}
                                    >
                                      <Pressable
                                        p={"10px"}
                                        shadow={1}
                                        bgColor={"gray.100"}
                                        _hover={{ bgColor: "gray.50" }}
                                        rounded={"full"}
                                        marginRight={"3px"}
                                        height={"36px"}
                                        top={"4px"}
                                        onPress={() => setOrgOpen(!isOrgOpen)}
                                      >
                                        <MoreHorizontalIcon
                                          height={"4px"}
                                          width={"16px"}
                                          size={"md"}
                                          color={"#000000"}
                                          style={{
                                            transform: [{ rotate: "90deg" }],
                                          }}
                                        />
                                      </Pressable>
                                      {isOrgOpen && (
                                        <Pressable
                                          backgroundColor={"gray.100"}
                                          shadow={9}
                                          width={"100px"}
                                          height={"40px"}
                                          padding={"10px"}
                                          position={"absolute"}
                                          _hover={{ bgColor: "gray.50" }}
                                          top={"47px"}
                                          right={"25px"}
                                          onPress={() =>
                                            handleProfileType("Group")
                                          }
                                        >
                                          <Text
                                            color={"black"}
                                            textAlign={"center"}
                                          >
                                            {Loc.currentLang.menu.add}
                                          </Text>
                                        </Pressable>
                                      )}
                                    </VStack>
                                  )}
                                </HStack>
                                <Pressable
                                  onPress={() => {
                                    //handleEditPopup();
                                    //setShowEditPopup(!showEditPopup);
                                  }}
                                ></Pressable>
                                {/*{showEditPopup && (*/}
                                {/*  <Box*/}
                                {/*    position={"absolute"}*/}
                                {/*    right={0}*/}
                                {/*    top={"43px"}*/}
                                {/*    background={"#f2f2f2"}*/}
                                {/*    borderRadius={"5px"}*/}
                                {/*    height="40px"*/}
                                {/*    width="150px"*/}
                                {/*  >*/}
                                {/*<Pressable*/}
                                {/*    onPress={handleRole}*/}
                                {/*    top='5px'*/}
                                {/*>*/}
                                {/*    <Text margin={'5px'} alignSelf='center'>*/}
                                {/*        {Loc.currentLang.menu.manageRoles}*/}
                                {/*    </Text>*/}
                                {/*</Pressable>*/}
                                {/*  </Box>*/}
                                {/*)}*/}
                              </HStack>
                            </HStack>
                          </VStack>
                          <Divider my={2} zIndex={-3} />

                          <HStack
                            flexWrap={"wrap"}
                            alignSelf={"flex-start"}
                            space={3}
                            p={2}
                            zIndex={-3}
                          >
                            {groupList?.length > 0 &&
                              groupList?.map((item) => (
                                <GroupListItem
                                  key={item.id}
                                  item={item}
                                  isAdminView={isAdminView}
                                  handleRemoveGroup={handleRemoveChild}
                                  navigate={navigate}
                                />
                              ))}
                          </HStack>

                          {(groupList?.length == 0 ||
                            groupList?.length == undefined) && (
                            <HStack
                              zIndex={-3}
                              width={"100%"}
                              top={isMobile ? "20px" : "0px"}
                              padding={isMobile ? "10px" : "10px"}
                              marginTop={isMobile ? "-10px" : "0px"}
                              space={isMobile ? 2 : 1}
                              marginLeft={isMobile ? "3px" : "5px"}
                            >
                              <img
                                src={inform}
                                style={{
                                  width: "20px",
                                  height: "20px",
                                }}
                              />
                              <Text
                                fontSize={"16px"}
                                fontWeight="400"
                                numberOfLines={4}
                                ellipsizeMode={"tail"}
                              >
                                {helpText}
                              </Text>
                            </HStack>
                          )}
                        </Box>
                      </>

                      //<AVCardList
                      //  tab={"Organization"}
                      //  isAdminView={isAdminView}
                      //  isCreate={isCreate}
                      //  setIsCreate={setIsCreate}
                      //  entity={entity!}
                      //  setEntity={setEntity}
                      //  menuRefs={menuRefs}
                      //  handleCreateOrg={handleCreateOrg}
                      //  handleProfileType={handleProfileType}
                      ///>
                    )}

                    {/* organization page*/}
                    {isOrganization && !isShowEdit && (
                      <>
                        <Box
                          minHeight={"340px"}
                          borderRadius={5}
                          backgroundColor={"AVColor.white"}
                          shadow={1}
                          flex={1}
                          mb={3}
                        >
                          <VStack>
                            <HStack
                              alignItems={"center"}
                              justifyContent={"space-between"}
                            >
                              <Text
                                fontWeight={"500"}
                                marginLeft={"15px"}
                                fontSize={"22px"}
                                color={"AVColor.primary"}
                                py={"12px"}
                              >
                                {entity?.type === "Club"
                                  ? Loc.currentLang.menu.teams
                                  : Loc.currentLang.menu.organization}
                              </Text>

                              <HStack alignItems={"center"} pr={2}>
                                <HStack zIndex={-3} space={3}>
                                  <Tooltip
                                    label={helpText}
                                    openDelay={500}
                                    w={200}
                                  >
                                    <Box
                                      marginRight={"10px"}
                                      p={"9px"}
                                      display={
                                        orgList?.length > 0 ||
                                        schoolYearOrgList?.length > 0
                                          ? ""
                                          : "none"
                                      }
                                      shadow={1}
                                      backgroundColor={"AVColor.liteBg"}
                                      rounded={"full"}
                                    >
                                      <img
                                        src={helping}
                                        height={"17px"}
                                        width={"17px"}
                                      />
                                    </Box>
                                  </Tooltip>
                                  {isAdminView && (
                                    <AVComDropdonwn
                                      dropdownValues={
                                        entity?.type === "SchoolYear"
                                          ? dropdownSchlYearsOrgValues
                                          : dropdownComOrgValues
                                      }
                                    />
                                  )}
                                  {isAdminView && (
                                    <VStack
                                      height={"40px"}
                                      width={"40px"}
                                      ref={menuRefs}
                                    >
                                      <Pressable
                                        p={"10px"}
                                        shadow={1}
                                        bgColor={"gray.100"}
                                        _hover={{ bgColor: "gray.50" }}
                                        rounded={"full"}
                                        marginRight={"3px"}
                                        height={"36px"}
                                        top={"4px"}
                                        onPress={() =>
                                          entity?.type === "SchoolYear"
                                            ? setIsSchoolYearsOrgTabOption(
                                                !isSchoolYearsOrgTabOption,
                                              )
                                            : setOrgOpen(!isOrgOpen)
                                        }
                                      >
                                        <MoreHorizontalIcon
                                          height={"4px"}
                                          width={"16px"}
                                          size={"md"}
                                          color={"#000000"}
                                          style={{
                                            transform: [{ rotate: "90deg" }],
                                          }}
                                        />
                                      </Pressable>

                                      {(isOrgOpen ||
                                        isSchoolYearsOrgTabOption) && (
                                        <Button
                                          backgroundColor={"gray.100"}
                                          shadow={9}
                                          width={"100px"}
                                          position={"absolute"}
                                          top={"47px"}
                                          right={"25px"}
                                          onPress={() =>
                                            handleProfileType("Organization")
                                          }
                                        >
                                          <Text color={"black"}>
                                            {Loc.currentLang.menu.add}
                                          </Text>
                                        </Button>
                                      )}
                                    </VStack>
                                  )}
                                </HStack>
                              </HStack>
                            </HStack>
                          </VStack>
                          <Divider my={2} zIndex={-3} />

                          <HStack
                            flexWrap={"wrap"}
                            zIndex={-3}
                            alignSelf={"flex-start"}
                            space={3}
                            p={2}
                          >
                            {[
                              ...new Map(
                                (isOrganization && orgList?.length > 0
                                  ? orgList
                                  : isSchoolYearOrgPage
                                    ? schoolYearOrgList
                                    : []
                                ).map((item) => [item.id, item]),
                              ).values(),
                            ].map((item: any) => (
                              <Box
                                key={item.id}
                                zIndex={-3}
                                bgColor={"#fff"}
                                borderWidth={"1px"}
                                borderColor={"AVColor.hovercolor2"}
                                minWidth={130}
                                minHeight={150}
                                borderRadius={5}
                                m={2}
                                shadow={1}
                              >
                                {isAdminView && (
                                  <Pressable
                                    key={item.id}
                                    padding={1.5}
                                    rounded={"full"}
                                    position={"absolute"}
                                    right={-10}
                                    top={-10}
                                    zIndex={999}
                                    _hover={{
                                      backgroundColor: "AVColor.hovercolor2",
                                    }}
                                    backgroundColor={"AVColor.buttonBg"}
                                    onPress={() =>
                                      isSchoolYearOrgPage
                                        ? HandleConfirmRemoveSchoolOrgs(
                                            "RemoveSchoolSeason",
                                            item,
                                          )
                                        : handleRemoveChild(item)
                                    }
                                  >
                                    <CloseIcon
                                      size={"12px"}
                                      color={"AVColor.secondaryText"}
                                    />
                                  </Pressable>
                                )}
                                <VStack
                                  alignItems={"center"}
                                  height={"100%"}
                                  width={"100%"}
                                >
                                  <Pressable
                                    key={item.id}
                                    height={"100%"}
                                    justifyContent={"center"}
                                    width={"100%"}
                                    _hover={{ bgColor: "#EEEEEE" }}
                                    onPress={() => {
                                      item?.type == "Person"
                                        ? navigate(
                                            `/profile/${item?.id}/${item?.region}`,
                                            {
                                              state: {
                                                user: {
                                                  id: item?.id,
                                                  pk: item?.pk,
                                                  region: item?.region,
                                                  type: item?.type,
                                                  name: item?.title,
                                                },
                                              },
                                            },
                                          )
                                        : item?.type == "PlayerOrg"
                                          ? navigate(
                                              `/season/${item?.id}/${item?.region}`,
                                              {
                                                state: {
                                                  isCreate: false,
                                                  team: item,
                                                },
                                              },
                                            )
                                          : item?.type == "Group"
                                            ? navigate(
                                                `/teams/${item?.id}/${item?.region}`,
                                                {
                                                  state: {
                                                    isCreate: false,
                                                    team: item,
                                                  },
                                                },
                                              )
                                            : item?.type == "Team"
                                              ? navigate(
                                                  `/teams/${item?.id}/${item?.region}`,
                                                  {
                                                    state: {
                                                      isCreate: false,
                                                      team: item,
                                                    },
                                                  },
                                                )
                                              : navigate(
                                                  `/teams/${item?.id}/${item?.region}`,
                                                  {
                                                    state: {
                                                      isCreate: false,
                                                      team: item,
                                                    },
                                                  },
                                                );
                                      setIsOrganization(false);
                                    }}
                                  >
                                    {item?.thumb && (
                                      <Box
                                        bgColor={"#FF6600"}
                                        borderRadius={["full"]}
                                        width={"70px"}
                                        height={"70px"}
                                        alignSelf={"center"}
                                        p={0}
                                      >
                                        <Image
                                          source={{
                                            uri: AV.Media.getThumb(item),
                                          }}
                                          borderRadius={["full"]}
                                          alt="Image"
                                          width={"100%"}
                                          height={["100%"]}
                                        />
                                      </Box>
                                    )}
                                    {!item?.thumb && (
                                      <Box
                                        bg="gray.100"
                                        borderRadius={["full"]}
                                        width={"70px"}
                                        height={"70px"}
                                        alignSelf={"center"}
                                        p={0}
                                      >
                                        <EntityProfilePic
                                          height={"70"}
                                          width={"70"}
                                          link={item}
                                        />
                                      </Box>
                                    )}
                                    <Tooltip label={item.title} openDelay={500}>
                                      <Pressable
                                        onPress={() => {
                                          item?.type == "Person"
                                            ? navigate(
                                                `/profile/${item?.id}/${item?.region}`,
                                                {
                                                  state: {
                                                    user: {
                                                      id: item?.id,
                                                      pk: item?.pk,
                                                      region: item?.region,
                                                      type: item?.type,
                                                      name: item?.title,
                                                    },
                                                  },
                                                },
                                              )
                                            : item?.type == "PlayerOrg"
                                              ? navigate(
                                                  `/season/${item?.id}/${item?.region}`,
                                                  {
                                                    state: {
                                                      isCreate: false,
                                                      team: item,
                                                    },
                                                  },
                                                )
                                              : item?.type == "Group"
                                                ? navigate(
                                                    `/teams/${item?.id}/${item?.region}`,
                                                    {
                                                      state: {
                                                        isCreate: false,
                                                        team: item,
                                                      },
                                                    },
                                                  )
                                                : item?.type == "Team"
                                                  ? navigate(
                                                      `/teams/${item?.id}/${item?.region}`,
                                                      {
                                                        state: {
                                                          isCreate: false,
                                                          team: item,
                                                        },
                                                      },
                                                    )
                                                  : navigate(
                                                      `/teams/${item?.id}/${item?.region}`,
                                                      {
                                                        state: {
                                                          isCreate: false,
                                                          team: item,
                                                        },
                                                      },
                                                    );
                                          setIsOrganization(false);
                                        }}
                                      >
                                        <Text
                                          marginTop={2}
                                          left={"2px"}
                                          alignItems="center"
                                          width="120px"
                                          numberOfLines={2}
                                          textAlign="center"
                                        >
                                          {item.title}
                                        </Text>
                                      </Pressable>
                                    </Tooltip>
                                  </Pressable>
                                </VStack>
                              </Box>
                            ))}
                          </HStack>

                          {(!isSchoolYearOrgPage
                            ? !orgList || orgList.length === 0
                            : !schoolYearOrgList ||
                              schoolYearOrgList.length === 0) && (
                            <HStack
                              zIndex={-3}
                              width="100%"
                              top={isMobile ? "20px" : "0px"}
                              padding="10px"
                              marginTop={isMobile ? "-10px" : "0px"}
                              space={2}
                            >
                              <img
                                src={inform}
                                alt="info"
                                style={{
                                  width: "20px",
                                  height: "20px",
                                }}
                              />
                              <Text
                                fontSize={"16px"}
                                fontWeight="400"
                                numberOfLines={4}
                                ellipsizeMode={"tail"}
                              >
                                {helpText}
                              </Text>
                            </HStack>
                          )}
                        </Box>
                      </>

                      //<AVCardList
                      //  tab={"Organization"}
                      //  isAdminView={isAdminView}
                      //  isCreate={isCreate}
                      //  setIsCreate={setIsCreate}
                      //  entity={entity!}
                      //  setEntity={setEntity}
                      //  menuRefs={menuRefs}
                      //  handleCreateOrg={handleCreateOrg}
                      //  handleCreateSchoolChilds={HandleCreateSchoolChilds}
                      //  handleProfileType={handleProfileType}
                      //  handleRemove={handleRemoveChild}
                      //  handleConfirmRemoveSchoolOrgs={HandleConfirmRemoveSchoolOrgs}
                      ///>
                    )}

                    {/* School/League Teams page*/}
                    {(isSchoolTeamsPage || isLeagueTeamsPage) &&
                      !isShowEdit && (
                        <AVCardList
                          tab={"Organization"}
                          isAdminView={isAdminView}
                          isCreate={isCreate}
                          setIsCreate={setIsCreate}
                          entity={entity!}
                          setEntity={setEntity}
                          menuRefs={menuRefs}
                          handleRemove={handleRemoveChild}
                          handleCreateOrg={handleCreateOrg}
                          handleCreateSchoolChilds={HandleCreateSchoolChilds}
                          handleProfileType={handleProfileType}
                          handleConfirmRemoveSchoolOrgs={
                            HandleConfirmRemoveSchoolOrgs
                          }
                        />
                      )}

                    {/* School Years page*/}
                    {isSchoolYearsPage && !isShowEdit && (
                      <AVCardList
                        tab={"Group"}
                        isAdminView={isAdminView}
                        isCreate={isCreate}
                        setIsCreate={setIsCreate}
                        entity={entity!}
                        setEntity={setEntity}
                        menuRefs={menuRefs}
                        handleCreateSchoolChilds={HandleCreateSchoolChilds}
                        handleConfirmRemoveSchoolOrgs={
                          HandleConfirmRemoveSchoolOrgs
                        }
                      />
                    )}

                    {/* School Alumni page*/}
                    {isSchoolAlumniPage && !isShowEdit && (
                      <AVCardList
                        tab={"Season"}
                        isAdminView={isAdminView}
                        isCreate={isCreate}
                        setIsCreate={setIsCreate}
                        entity={entity!}
                        setEntity={setEntity}
                        menuRefs={menuRefs}
                      />
                    )}

                    {/* School/Alumni/SchoolYear GradClass page*/}
                    {(isSchoolGradClassPage ||
                      isSchoolAlumniGradClassPage ||
                      isSchoolYearGradClassPage) &&
                      !isShowEdit && (
                        <AVCardList
                          tab={"GradClass"}
                          isAdminView={isAdminView}
                          isCreate={isCreate}
                          setIsCreate={setIsCreate}
                          entity={entity!}
                          setEntity={setEntity}
                          handleCreateSchoolChilds={HandleCreateSchoolChilds}
                          handleConfirmRemoveSchoolOrgs={
                            HandleConfirmRemoveSchoolOrgs
                          }
                        />
                      )}

                    {/* Fee Collection page*/}
                    {isFeeCollectionPage && !isShowEdit && (
                      <AVFeeCollection
                        entity={entity as AV.ICollect}
                        setEntity={setEntity}
                        seriesId={seriesId ?? ""}
                        isAdminView={isAdminView}
                        isOngoingOrFuture={
                          isOngoingOrFuture || isEntireSeriesAvailable
                        }
                      />
                    )}

                    {/* Fee Collection About page */}
                    {isCollectAboutPage &&
                      ((entity as AV.IAVEntity)?.profile?.text?.trim().length ??
                        0) > 0 &&
                      !isShowEdit && <AVFeeCollectAbout entity={entity!} />}

                    {/* Fee Collection Member page*/}
                    {isCollectMembersPage && !isShowEdit && (
                      <AVFeeCollectMembers
                        entity={entity as AV.ICollect}
                        setEntity={setEntity}
                        isAdminView={isAdminView}
                        eventSeriesId={params?.seriesId}
                        handleProfileType={handleProfileType}
                        isOngoingOrFuture={
                          isOngoingOrFuture || isEntireSeriesAvailable
                        }
                      />
                    )}

                    {/* LeagueSeason Games page*/}
                    {isLeagueGamesPage && !isShowEdit && (
                      <AVCardList
                        tab={"LeagueGame"}
                        isAdminView={isAdminView}
                        isCreate={isCreate}
                        setIsCreate={setIsCreate}
                        entity={entity!}
                        setEntity={setEntity}
                        handleRemove={handleRemoveChild}
                        onboardingFlow={onboardingFlow}
                        onboardingStep={onboardingStep}
                        setOnboardingStep={setOnboardingStep}
                        clearCurrentTourFlow={clearCurrentTourFlow}
                      />
                    )}

                    {/* LeagueGame Teams page*/}
                    {isGameTeamsPage && !isShowEdit && (
                      <AVCardList
                        tab={"LeagueGameTeams"}
                        isAdminView={isAdminView}
                        isCreate={isCreate}
                        setIsCreate={setIsCreate}
                        entity={entity!}
                        setEntity={setEntity}
                        onboardingFlow={onboardingFlow}
                        onboardingStep={onboardingStep}
                        setOnboardingStep={setOnboardingStep}
                        clearCurrentTourFlow={clearCurrentTourFlow}
                      />
                    )}

                    {/* feedback page*/}
                    {isFeebackGroup && !isShowEdit && (
                      <Box
                        zIndex={isDropDown ? -3 : ""}
                        minHeight={"340px"}
                        borderRadius={5}
                        backgroundColor={"AVColor.white"}
                        shadow={1}
                        flex={1}
                        mb={3}
                      >
                        <VStack>
                          <HStack
                            flexWrap={"wrap"}
                            zIndex={-2}
                            alignSelf={"flex-start"}
                            space={3}
                            p={2}
                          >
                            {isShowTeamsList?.length > 0 &&
                              isShowTeamsList?.map((item, i) => (
                                <Box
                                  key={item.id ?? i}
                                  bgColor={"#fff"}
                                  borderWidth={"1px"}
                                  borderColor={"AVColor.hovercolor2"}
                                  minWidth={130}
                                  minHeight={175}
                                  borderRadius={5}
                                  marginLeft={2}
                                  marginY={2}
                                  py={3}
                                  shadow={1}
                                >
                                  <VStack
                                    key={item?.id}
                                    alignItems={"flex-start"}
                                    padding={2}
                                    height={"100%"}
                                    width={"100%"}
                                  >
                                    <Pressable
                                      height={"100%"}
                                      width={"100%"}
                                      key={item?.id}
                                      _hover={{ bgColor: "gray.100" }}
                                      p={2}
                                      borderRadius={5}
                                      minWidth={120}
                                      onPress={() => {
                                        navigate(
                                          `/teams/${item?.id}/${item?.region}`,
                                          {
                                            state: {
                                              isCreate: false,
                                              team: item,
                                              type: "Group",
                                            },
                                          },
                                        );
                                        setIsFeedBackGroup(false);
                                      }}
                                    >
                                      {item?.thumb && (
                                        <Box
                                          bgColor={"#FF6600"}
                                          borderRadius={["full"]}
                                          width={"60px"}
                                          height={"60px"}
                                          alignSelf={"center"}
                                        >
                                          <Image
                                            source={{
                                              uri: AV.Media.getThumb(item),
                                            }}
                                            borderRadius={["full"]}
                                            width={"100%"}
                                            height={["100%"]}
                                            alt="Image"
                                          />
                                        </Box>
                                      )}
                                      {!item?.thumb && (
                                        <Box alignItems={"center"}>
                                          <Profile
                                            height={"60"}
                                            width={"60"}
                                            color={"#32AE78"}
                                          />
                                        </Box>
                                      )}
                                      <Tooltip
                                        label={item?.title ?? ""}
                                        openDelay={500}
                                      >
                                        <Pressable
                                          onPress={() => {
                                            navigate(
                                              `/teams/${item?.id}/${item?.region}`,
                                              {
                                                state: {
                                                  isCreate: false,
                                                  team: item,
                                                },
                                              },
                                            );
                                          }}
                                        >
                                          <Text
                                            numberOfLines={1}
                                            maxWidth={"100px"}
                                            alignSelf={"center"}
                                            fontWeight={"500"}
                                          >
                                            {item?.title}
                                          </Text>
                                        </Pressable>
                                      </Tooltip>
                                    </Pressable>
                                  </VStack>
                                </Box>
                              ))}
                          </HStack>
                        </VStack>
                      </Box>
                    )}

                    {/* member page*/}
                    {isMembersPage && !isShowEdit && (
                      <AVCardList
                        tab={"Members"}
                        isAdminView={isAdminView}
                        isCreate={isCreate}
                        setIsCreate={setIsCreate}
                        entity={entity!}
                        setEntity={setEntity}
                        handleChat={handleChat}
                        createConvoKey={"M"}
                        handleGroupChat={HandleGroupChat}
                        handleRemoveGroup={HandleRemoveMembers}
                        handleProfileType={handleProfileType}
                        setIsMoreMenuDrp={setIsDropDown}
                        handleHomeClick={handleHomeClick}
                        onboardingFlow={onboardingFlow}
                        onboardingStep={onboardingStep}
                        setOnboardingStep={setOnboardingStep}
                        clearCurrentTourFlow={clearCurrentTourFlow}
                      />
                    )}

                    {/* photo page*/}
                    {isPhotoPage && !isShowEdit && (
                      <Createalbumpopup
                        isDocumentPage={isDocumentPage}
                        isRecordsPage={isRecordsPage}
                        Parentdata={entity}
                        isOwner={isAdminView}
                        isPhotoPage={isPhotoPage}
                        albumlist={albumList}
                        setalbumlist={setAlbumList}
                        filesList={filesList}
                        setfilesList={setFilesList}
                        filesListany={undefined}
                        editAccess={
                          isOngoingOrFuture || isEntireSeriesAvailable
                        }
                        helpText={helpText}
                      />
                    )}

                    {/* document page*/}
                    {(isDocumentPage || isRecordsPage) &&
                      !isShowEdit &&
                      !isCreate && (
                        <Createalbumpopup
                          isDocumentPage={isDocumentPage}
                          isRecordsPage={isRecordsPage}
                          Parentdata={entity}
                          isPhotoPage={isPhotoPage}
                          albumlist={albumList}
                          isOwner={isAdminView}
                          setalbumlist={setAlbumList}
                          filesList={filesList}
                          setfilesList={setFilesList}
                          recordList={recordList}
                          setRecordList={setRecordList}
                          filesListany={undefined}
                          editAccess={
                            isOngoingOrFuture ||
                            isEntireSeriesAvailable ||
                            leagueGameEntity?.status === "Started"
                          }
                          helpText={helpText}
                        />
                      )}

                    {/* occurence page*/}
                    {isOccurencePage && !isShowEdit && (
                      <Box
                        width={"100%"}
                        minHeight={"340px"}
                        marginRight={4}
                        p={2}
                        h="auto"
                        shadow={1}
                        bgColor="#fff"
                        rounded="lg"
                      >
                        <HStack flexWrap={"wrap"}>
                          <RenderSeriesEvents
                            seriesEventsList={seriesEventsList}
                            event={entity}
                            setEntity={setEntity}
                            setEntityDatas={setEntitydata}
                          />
                        </HStack>
                      </Box>
                    )}

                    {/* feeds page*/}
                    <Box
                      mt={[5]}
                      justifyContent={"space-between"}
                      maxWidth={[1063]}
                      paddingRight={0}
                      height={"auto"}
                      marginBottom={"30px"}
                    >
                      {!isShowEdit &&
                        (isTeamsPage || isGamePostPage) &&
                        entity &&
                        entity?.status !== "Deleted" &&
                        entity?.status !== "Collect" && (
                          <>
                            <VStack
                              borderRadius={12}
                              bgColor={"#fff"}
                              maxWidth={[1052]}
                              flex={1}
                              ref={rightRef}
                            >
                              <VStack
                                alignItems={"spece-around"}
                                marginTop={"-20px"}
                              >
                                <AVFeedsProfile
                                  Entity={entity}
                                  iscommentAccess={
                                    isStaffEntity ||
                                    isMemberEntity ||
                                    isPlayerEntity
                                  }
                                  isOwner={
                                    isAdminView
                                      ? isAdminView
                                      : ((entity as AV.IOrgBase)?.staff?.filter(
                                            (x) => x?.id === currentUser?.id,
                                          )?.length ?? 0) > 0
                                        ? true
                                        : false
                                  }
                                  id={entity?.id}
                                  isFollowing={isFollowing}
                                  Postdata={entity}
                                  offW={fixedWidth}
                                  isShowCreatePost={
                                    !(
                                      (
                                        entity?.status === "Canceled" ||
                                        (
                                          entity as AV.IEvent
                                        )?.seriesEvents?.find(
                                          (x) => x.id === seriesId,
                                        )?.status === "Canceled"
                                      )
                                      //|| isOngoingOrFuture
                                    )
                                  }
                                  entityType={entity?.type}
                                  isOngoingOrFuture={
                                    isOngoingOrFuture ||
                                    isEntireSeriesAvailable ||
                                    leagueGameEntity?.status === "Started" ||
                                    (entity?.type === "LeagueGameBase" &&
                                      entity?.status === "Started")
                                  }
                                  //isEntireSeriesAvailable={isEntireSeriesAvailable}
                                  {...props}
                                />
                              </VStack>
                            </VStack>
                          </>
                        )}
                    </Box>
                  </VStack>
                </VStack>
              </HStack>
            </HStack>
          </>
        )}
      </AVBody>

      {showFileUploadModal && (
        <Box
          position="fixed"
          bgColor={"AVColor.overlay2"}
          bottom={0}
          right={0}
          top={0}
          left={0}
          zIndex={99}
        >
          <Modal.Content
            bgColor={"#fff"}
            maxWidth={"100%"}
            width={"50%"}
            padding={"24px"}
            minHeight={[500]}
            left={"22%"}
            top={"20%"}
          >
            <HStack fontSize={"24px"} fontWeight={400} marginBottom={"24px"}>
              {isStaff
                ? Loc.currentLang.menu.staff
                : isPlayer &&
                    ((entity as AV.IOrgBase)?.subType === "Class" ||
                      (entity as AV.IOrgBase)?.subType === "GradClass")
                  ? Loc.currentLang.menu.addStudents
                  : isPlayer
                    ? Loc.currentLang.menu.players
                    : entity?.type === "PlayerOrg" ||
                        (entity as AV.IOrgBase)?.subType === "Class"
                      ? Loc.currentLang.menu.parents
                      : entity?.type === "Event"
                        ? Loc.currentLang.menu.participants
                        : Loc.currentLang.menu.members}
            </HStack>

            <VStack
              marginTop={"10px"}
              space={4}
              width={"auto"}
              overflowY={"auto"}
              height={"334px"}
              justifyContent={"flex-start"}
            >
              <HStack
                flexWrap={"wrap"}
                alignSelf={"flex-start"}
                space={6}
                zIndex={-1}
                justifyContent={"center"}
                height={"100px"}
                width={"98%"}
              >
                {contactList?.map((item) => (
                  <>
                    <HStack
                      alignItems={"center"}
                      borderStyle={"solid"}
                      borderColor={"rgba(0, 0, 0, 0.05)"}
                      borderRadius={"5px"}
                      width={"100%"}
                    >
                      <VStack
                        width={"100%"}
                        space={
                          item?.parentName ||
                          item?.parentEmail ||
                          item?.parentPhone
                            ? 8
                            : 4
                        }
                      >
                        <HStack width={"85%"}>
                          <HStack marginRight={"10px"} width={"30%"}>
                            {!isEditPlayerDetails || contactMenu !== item ? (
                              <Text
                                fontWeight="500"
                                numberOfLines={1}
                                ellipsizeMode={"tail"}
                                fontSize={"16px"}
                                textAlign={"left"}
                                color={"#000000"}
                                width={"100%"}
                                textTransform={"capitalize"}
                              >
                                {item?.name}
                              </Text>
                            ) : (
                              <Box width={"80%"} marginTop={"3px"}>
                                <Input
                                  textAlign={"left"}
                                  fontSize={"16px"}
                                  paddingLeft={"0px"}
                                  paddingRight={"0px"}
                                  value={newName}
                                  defaultValue={contactMenu?.name}
                                  onChangeText={(e) => setNewName(e)}
                                />
                              </Box>
                            )}
                          </HStack>

                          <HStack width={"48%"} marginRight={"10px"}>
                            {!isEditPlayerDetails || contactMenu !== item ? (
                              <Text
                                fontSize={"16px"}
                                width={"100%"}
                                numberOfLines={1}
                                ellipsizeMode={"tail"}
                                textAlign={"left"}
                              >
                                {item?.email}
                              </Text>
                            ) : (
                              <Box width={"80%"} marginTop={"3px"}>
                                <Input
                                  textAlign={"left"}
                                  fontSize={"16px"}
                                  paddingLeft={"0px"}
                                  paddingRight={"0px"}
                                  value={newMail}
                                  defaultValue={contactMenu?.email}
                                  onChangeText={(e) => setNewMail(e)}
                                />
                              </Box>
                            )}
                          </HStack>

                          {isStaff && (
                            <HStack width={"16%"} marginRight={"10px"}>
                              {!isEditPlayerDetails || contactMenu !== item ? (
                                <Text
                                  fontSize={"16px"}
                                  width={"100%"}
                                  textAlign={"left"}
                                  color={"#000000"}
                                >
                                  {isStaff
                                    ? item?.role?.[0]?.name
                                      ? item?.role?.[0]?.name
                                      : ((entity as AV.IOrgBase)?.roles?.[0]
                                          ?.name ?? "")
                                    : ""}
                                </Text>
                              ) : (
                                <HStack width={"65%"} marginTop={"10px"}>
                                  <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">
                                      {Loc.currentLang.menu.roles}
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      value={staffRole}
                                      label={Loc.currentLang.menu.roles}
                                      onChange={(e) =>
                                        setStaffRole(e.target.value)
                                      }
                                      style={
                                        isMobile
                                          ? customSelectStyle
                                          : customSelectStyleeeess
                                      }
                                    >
                                      {(entity as AV.IOrgBase)?.roles?.map(
                                        (option) => (
                                          <MenuItem
                                            key={option?.name}
                                            value={option?.name}
                                          >
                                            {option?.name}
                                          </MenuItem>
                                        ),
                                      )}
                                    </Select>
                                  </FormControl>
                                </HStack>
                              )}
                            </HStack>
                          )}

                          {item?.phone && (
                            <HStack width={"16%"} marginRight={"10px"}>
                              {!isEditPlayerDetails || contactMenu !== item ? (
                                <Text
                                  fontSize={"16px"}
                                  width={"100%"}
                                  textAlign={"left"}
                                  color={"#000000"}
                                >
                                  {item?.phone}
                                </Text>
                              ) : (
                                <HStack width={"65%"} marginTop={"10px"}>
                                  <Input
                                    textAlign={"left"}
                                    fontSize={"16px"}
                                    paddingLeft={"0px"}
                                    paddingRight={"0px"}
                                    value={newPhone}
                                    defaultValue={contactMenu?.phone}
                                    onChangeText={(e) => setNewPhone(e)}
                                  />
                                </HStack>
                              )}
                            </HStack>
                          )}
                        </HStack>

                        {(item?.parentName ||
                          item?.parentEmail ||
                          item?.parentPhone) && (
                          <HStack width={"85%"}>
                            {item?.parentName && (
                              <HStack marginRight={"10px"} width={"30%"}>
                                {!isEditPlayerDetails ||
                                contactMenu !== item ? (
                                  <Text
                                    fontWeight="500"
                                    numberOfLines={1}
                                    ellipsizeMode={"tail"}
                                    fontSize={"16px"}
                                    textAlign={"left"}
                                    color={"#000000"}
                                    width={"100%"}
                                    textTransform={"capitalize"}
                                  >
                                    {item?.parentName}
                                  </Text>
                                ) : (
                                  <Box width={"80%"} marginTop={"3px"}>
                                    <Input
                                      textAlign={"left"}
                                      fontSize={"16px"}
                                      paddingLeft={"0px"}
                                      paddingRight={"0px"}
                                      value={newParentName}
                                      defaultValue={contactMenu?.parentName}
                                      onChangeText={(e) => setNewParentName(e)}
                                    />
                                  </Box>
                                )}
                              </HStack>
                            )}

                            {item?.parentEmail && (
                              <HStack width={"48%"} marginRight={"10px"}>
                                {!isEditPlayerDetails ||
                                contactMenu !== item ? (
                                  <Text
                                    fontSize={"16px"}
                                    width={"100%"}
                                    numberOfLines={1}
                                    ellipsizeMode={"tail"}
                                    textAlign={"left"}
                                  >
                                    {item?.parentEmail}
                                  </Text>
                                ) : (
                                  <Box width={"80%"} marginTop={"3px"}>
                                    <Input
                                      textAlign={"left"}
                                      fontSize={"16px"}
                                      paddingLeft={"0px"}
                                      paddingRight={"0px"}
                                      value={newParentEmail}
                                      defaultValue={contactMenu?.parentEmail}
                                      onChangeText={(e) => setNewParentEmail(e)}
                                    />
                                  </Box>
                                )}
                              </HStack>
                            )}

                            {item?.parentPhone && (
                              <HStack width={"16%"} marginRight={"10px"}>
                                {!isEditPlayerDetails ||
                                contactMenu !== item ? (
                                  <Text
                                    fontSize={"16px"}
                                    width={"100%"}
                                    textAlign={"left"}
                                    color={"#000000"}
                                  >
                                    {item?.parentPhone}
                                  </Text>
                                ) : (
                                  <HStack width={"65%"} marginTop={"10px"}>
                                    <Input
                                      textAlign={"left"}
                                      fontSize={"16px"}
                                      paddingLeft={"0px"}
                                      paddingRight={"0px"}
                                      value={newParentPhone}
                                      defaultValue={contactMenu?.parentPhone}
                                      onChangeText={(e) => setNewParentPhone(e)}
                                    />
                                  </HStack>
                                )}
                              </HStack>
                            )}
                          </HStack>
                        )}

                        <HStack width={"85%"}>
                          {(!isEditPlayerDetails || contactMenu !== item) && (
                            <Button
                              backgroundColor={"white"}
                              width={"50px"}
                              height={
                                item?.parentName ||
                                item?.parentEmail ||
                                item?.parentPhone
                                  ? "20px"
                                  : "40px"
                              }
                              isDisabled={isLoading}
                              onPress={() => {
                                setNewMail(item?.email ?? "");
                                setStaffRole(
                                  item?.role?.[0]?.name ??
                                    (entity as AV.IOrgBase)?.roles?.[0]?.name ??
                                    "",
                                );
                                setNewName(item?.name ?? "");
                                setNewPhone(item?.phone ?? "");
                                setNewParentName(item?.parentName ?? "");
                                setNewParentEmail(item?.parentEmail ?? "");
                                setNewParentPhone(item?.parentPhone ?? "");
                                setIsEditPlayerDetails(true);
                              }}
                            >
                              <HStack>
                                <Text
                                  fontSize={"16px"}
                                  underline
                                  textAlign={"center"}
                                  color={"#00A7BC"}
                                >
                                  {Loc.currentLang.menu.edit}
                                </Text>
                              </HStack>
                            </Button>
                          )}{" "}
                          {isEditPlayerDetails && contactMenu === item && (
                            <Button
                              backgroundColor={"white"}
                              width={"50px"}
                              height={
                                item?.parentName ||
                                item?.parentEmail ||
                                item?.parentPhone
                                  ? "20px"
                                  : "40px"
                              }
                              onPress={() => {
                                handleUpdateStaff(item);
                              }}
                            >
                              <HStack>
                                <Text
                                  fontSize={"16px"}
                                  underline
                                  textAlign={"center"}
                                  color={"#00A7BC"}
                                >
                                  {Loc.currentLang.menu.update}
                                </Text>
                              </HStack>
                            </Button>
                          )}
                          <Button
                            backgroundColor={"white"}
                            height={
                              item?.parentName ||
                              item?.parentEmail ||
                              item?.parentPhone
                                ? "20px"
                                : "40px"
                            }
                            width={"50px"}
                            isDisabled={isLoading}
                            onPress={() => handleRemoveStaff(item)}
                          >
                            <HStack>
                              <Text
                                fontSize={"16px"}
                                underline
                                textAlign={"center"}
                                color={"#DF2827"}
                              >
                                {Loc.currentLang.menu.delete}
                              </Text>
                            </HStack>
                          </Button>
                        </HStack>
                      </VStack>
                    </HStack>
                    <Divider marginTop={"5px"} />
                  </>
                ))}
              </HStack>
            </VStack>

            <HStack
              width={"100%"}
              space={5}
              flex={1}
              justifyContent={"flex-end"}
              alignItems={"top"}
              pr={5}
              top={"88%"}
              position="absolute"
              right="10px"
              maxHeight={"200px"}
              padding={0}
              background={"none"}
            >
              <Button
                background={"#EEEEEE"}
                borderRadius={15}
                px={16}
                height={"40px"}
                width={"40px"}
                rounded="full"
                onPress={() => {
                  setShowFileUploadModal(false);
                }}
              >
                <Text color={"#000000"}>{Loc.currentLang.menu.cancel}</Text>
              </Button>

              <Button
                bgColor={"AVColor.primary"}
                height={"40px"}
                isLoading={isLoading}
                isLoadingText={Loc.currentLang.menu.saveLoad}
                width={"40px"}
                borderRadius={15}
                px={16}
                rounded="full"
                isDisabled={contactList?.length === 0}
                onPress={handleAddContactList}
              >
                <Text color={"#ffffff"}>{Loc.currentLang.menu.save}</Text>
              </Button>
            </HStack>
          </Modal.Content>
        </Box>
      )}

      {isStaffReq && (
        <Box
          position="fixed"
          bgColor={"AVColor.overlay2"}
          bottom={0}
          right={0}
          top={0}
          left={0}
          zIndex={9999}
        >
          <div
            className={`create_post_popup ${mobile && "create_post_popup_mobile"}`}
            style={{
              width: mobile ? dimensions.width - 15 : "600px",
              height: "auto",
              marginTop: "12px",
            }}
          >
            <VStack height={"100%"} width={"100%"} padding={"24px"}>
              <HStack>
                <Text fontWeight={400} fontSize={"30px"}>
                  {Loc.currentLang.menu.staffRequest}
                </Text>
              </HStack>
              <HStack marginY={"24px"}>
                <Text fontWeight={500} fontSize={"16px"}>
                  {Loc.currentLang.menu.staffRequestFormSubmission}
                </Text>
              </HStack>

              <Box>
                <AVInputtext
                  type={"text"}
                  minRows="1"
                  size="medium"
                  multiline={true}
                  maxLength={250}
                  onChange={(e) => setStaffDesc(e?.target?.value)}
                  defaultValue={undefined}
                  width={undefined}
                  value={staffDesc}
                  label={`${Loc.currentLang.menu.justification} *`}
                  placeholder={undefined}
                />
              </Box>

              <HStack
                justifyContent={"center"}
                top={"65%"}
                space={"24px"}
                marginTop={"24px"}
              >
                <Button
                  width={"20%"}
                  height={"40px"}
                  borderRadius={"19px"}
                  backgroundColor={"#e5e5e5"}
                  onPress={() => {
                    setIsStaffReq(false);
                    setStaffDesc("");
                  }}
                >
                  <Text
                    color={"rgba(0,0,0,0.5)"}
                    fontWeight={500}
                    fontSize={[14, 16]}
                  >
                    {Loc.currentLang.menu.cancel}
                  </Text>
                </Button>

                <Button
                  width={"22%"}
                  height={"40px"}
                  borderRadius={"19px"}
                  backgroundColor={"AVColor.primary"}
                  isLoading={isLoader}
                  isDisabled={!staffDesc.trim()}
                  onPress={() => handlestaffandorgReq()}
                >
                  <Text color={"white"} fontWeight={500} fontSize={[14, 16]}>
                    {Loc.currentLang.richText.imageBox.submitButton}
                  </Text>
                </Button>
              </HStack>
            </VStack>
          </div>
        </Box>
      )}

      {isChildOrgReq && (
        <Box
          position="fixed"
          bgColor={"AVColor.overlay2"}
          bottom={0}
          right={0}
          top={0}
          left={0}
          zIndex={9999}
        >
          <div
            className={`create_post_popup ${mobile && "create_post_popup_mobile"}`}
            style={{
              width: mobile ? dimensions.width - 15 : "600px",
              height: "auto",
              marginTop: "12px",
            }}
          >
            <VStack height={"100%"} width={"100%"} padding={"24px"}>
              <HStack>
                <Text fontWeight={400} fontSize={"30px"}>
                  {Loc.currentLang.menu.childOrganizationRequest}
                </Text>
              </HStack>
              <HStack marginY={"24px"}>
                <Text fontWeight={500} fontSize={"16px"}>
                  {Loc.currentLang.menu.requestForAddingaChildOrganization}
                </Text>
              </HStack>

              <Box marginBottom={"24px"}>
                <AVInputtext
                  type={"text"}
                  label={Loc.currentLang.menu.selectOrganization}
                  maxLength={50}
                  onChange={(e) => searchOrgs(e?.target?.value)}
                  defaultValue={undefined}
                  width={undefined}
                  value={childOrgOne}
                  height={undefined}
                  minRows={undefined}
                  multiline={undefined}
                  size={undefined}
                  placeholder={undefined}
                />
              </Box>

              {childOrgOne?.length > 0 &&
                isDropList &&
                selectChildOrg?.map((item) => (
                  <VStack
                    width={"300px"}
                    height={"auto"}
                    shadow={2}
                    padding={"24px"}
                    background={"#FFFFFF"}
                    position={"absolute"}
                    top={"50%"}
                    zIndex={999}
                    borderRadius={"6px"}
                  >
                    <Pressable
                      width={"250px"}
                      height={"36px"}
                      alignItems={"center"}
                      justifyContent={"center"}
                      onPress={() => {
                        setChildOrgOne(item?.title ?? "");
                        setChildOrgId(item);
                        setIsDropList(false);
                      }}
                    >
                      <Text
                        fontSize={"14px"}
                        fontFamily={"Roboto"}
                        numberOfLines={1}
                        width={"250px"}
                      >
                        {item?.title}
                      </Text>
                    </Pressable>
                  </VStack>
                ))}

              <Box>
                <AVInputtext
                  type={"text"}
                  minRows="1"
                  size="medium"
                  multiline={true}
                  maxLength={250}
                  onChange={(e) => setJusti(e?.target?.value)}
                  defaultValue={undefined}
                  width={undefined}
                  value={justi}
                  height={"60px"}
                  label={Loc.currentLang.menu.justification}
                  placeholder={undefined}
                />
              </Box>

              <HStack
                justifyContent={"center"}
                top={"65%"}
                space={"24px"}
                marginTop={"24px"}
              >
                <Button
                  width={"20%"}
                  height={"40px"}
                  borderRadius={"19px"}
                  backgroundColor={"#e5e5e5"}
                  onPress={() => {
                    setIsChildOrgReq(false);
                    setJusti("");
                    setChildOrgOne("");
                    setChildOrgId(null);
                  }}
                >
                  <Text
                    color={"rgba(0,0,0,0.5)"}
                    fontWeight={500}
                    fontSize={[14, 16]}
                  >
                    {Loc.currentLang.menu.cancel}
                  </Text>
                </Button>

                <Button
                  width={"22%"}
                  height={"40px"}
                  borderRadius={"19px"}
                  backgroundColor={"AVColor.primary"}
                  isDisabled={!childOrgId || !justi}
                  isLoading={isLoader}
                  onPress={() => handlestaffandorgReq()}
                >
                  <Text color={"white"} fontWeight={500} fontSize={[14, 16]}>
                    {Loc.currentLang.richText.imageBox.submitButton}
                  </Text>
                </Button>
              </HStack>
            </VStack>
          </div>
        </Box>
      )}

      {isImagePopup && (
        /*View Map popup*/
        <Box
          position={"fixed"}
          top={0}
          bottom={0}
          left={0}
          right={0}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"center"}
          backgroundColor={"rgba(0, 0, 0, 0.25)"}
          zIndex={9999}
        >
          <div className={`show_unauthorized_details`}>
            <HStack
              alignItems={"center"}
              justifyContent={"flex-end"}
              borderBottomColor={"AVColor.grey"}
              px={5}
              py={3}
              zIndex={99}
              width={isMobile ? "85%" : ""}
            >
              <AVCancel
                color={undefined}
                size={undefined}
                callback={() => setIsImagePopup(false)}
              />
            </HStack>

            <HStack width={isMobile ? "90%" : "100%"} height={"100%"} space={3}>
              {(entity as AV.IOrgBase)?.location?.siteMap?.type?.startsWith(
                "image",
              ) ? (
                <Pressable
                  width={isMobile ? "90%" : "100%"}
                  height={"80%"}
                  onPress={() => {
                    openPreview(
                      (entity as AV.IOrgBase)?.location?.siteMap,
                      allImages,
                    );
                    setIsImagePopup(false);
                  }}
                >
                  <img
                    src={Media.getURL(
                      (entity as AV.IOrgBase)?.location?.siteMap,
                    )}
                    alt="sitemap"
                    height={"100%"}
                    width={"100%"}
                    style={{ objectFit: "contain" }}
                  />
                </Pressable>
              ) : (
                <Pressable
                  width={isMobile ? "90%" : "100%"}
                  height={"80%"}
                  onPress={() => {
                    handledocument((entity as AV.IOrgBase)?.location?.siteMap);
                  }}
                >
                  <img
                    //@ts-ignore
                    src={
                      ((entity as AV.IOrgBase)?.location?.siteMap?.type ===
                        "application/pdf" &&
                        settings.pdf) ||
                      (((entity as AV.IOrgBase)?.location?.siteMap?.type ===
                        "application/msword" ||
                        (entity as AV.IOrgBase)?.location?.siteMap?.type ===
                          "application/vnd.openxmlformats-officedocument.wordprocessingml.document") &&
                        settings.word) ||
                      (((entity as AV.IOrgBase)?.location?.siteMap?.type ===
                        "application/vnd.ms-powerpoint" ||
                        (entity as AV.IOrgBase)?.location?.siteMap?.type ===
                          "application/vnd.openxmlformats-officedocument.presentationml.presentation") &&
                        settings.powerpoint) ||
                      (((entity as AV.IOrgBase)?.location?.siteMap?.type ===
                        "application/vnd.ms-excel" ||
                        (entity as AV.IOrgBase)?.location?.siteMap?.type ===
                          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") &&
                        settings.excel) ||
                      (((entity as AV.IOrgBase)?.location?.siteMap?.type ===
                        "text/plain" ||
                        (entity as AV.IOrgBase)?.location?.siteMap?.type ===
                          "text/plain") &&
                        settings.file) ||
                      settings.file
                    }
                    style={{
                      margin: "1px",
                      objectFit: "contain",
                      height: "100%",
                      width: "100%",
                    }}
                  />
                </Pressable>
              )}
            </HStack>
          </div>
        </Box>
      )}

      {showAddProfileModal && (
        <AVPersonaModal
          isMember={isMember}
          isParticipant={isParticipant}
          setShowAddProfileModal={setShowAddProfileModal}
          isStaff={isStaff}
          Entity={entity!}
          setEntity={setEntity}
          setcontactList={setContactList}
          setshowFileuploadModal={setShowFileUploadModal}
          setStaffList={setStaffList}
          isPlayer={isPlayer}
          setPlayersList={setPlayersList}
          showAddProfileModal={showAddProfileModal}
          isTeam={isTeam}
          searchTypes={searchTypes}
          setOrgList={setOrgList}
          setGroupList={setGroupList}
          isEditEntireSeries={isEditEntireSeries}
          seriesEvent={seriesEvent}
          isSchoolTeamsPage={isSchoolTeamsPage}
          onboardingFlow={onboardingFlow}
          onboardingStep={onboardingStep}
          setOnboardingStep={setOnboardingStep}
          clearCurrentTourFlow={clearCurrentTourFlow}
        />
      )}

      {isConfirmDelete && (
        <AVConfirmationModal
          showconfirmationPopup={isConfirmDelete}
          setshowconfirmationPopup={setIsConfirmDelete}
          Confirmationtext={confirmText}
          type={selectType}
          item={itemSelect}
          function={
            selectType == "RestoreAccount"
              ? handleRestore
              : selectType == "DeleteSeason"
                ? RemoveSeason
                : selectType == "RemoveSchoolSeason"
                  ? HandleRemoveSchoolOrgs
                  : selectType == "RemoveSchoolGradClass"
                    ? HandleRemoveSchoolOrgs
                    : selectType == "DeleteStaff"
                      ? RemoveStaffs
                      : selectType == "DeleteParticipant"
                        ? RemoveParticiapnt
                        : selectType == "DeletePlayer"
                          ? handleRemoveplayers
                          : selectType == "RemoveResource"
                            ? handleRemoveResourses
                            : selectType == "DeleteMember"
                              ? handleDeleteMember
                              : selectType == "DeleteChild"
                                ? handleDeleteChild
                                : selectType == "ToggleSilence"
                                  ? handleToggleSilence
                                  : ""
          }
          isLoader={isLoader}
        />
      )}

      {showAddEventsModal && (
        <AVCreateEventModal
          entity={entity!}
          repeatWeek={repeatWeek}
          setRepeatWeek={setRepeatWeek}
          isPractice={isPractice}
          setShowAddEventsModal={setShowAddEventsModal}
          typeEvent={typeEvent}
          setLocationAddress={setLocationAddress}
          locationAddress={locationAddress}
          isShowEdit={isShowEdit}
          showAddEventsModal={showAddEventsModal}
          isEditEntireSeries={isEditEntireSeries}
          setClickedUrl={setClickedUrl}
          setShowConfirmLinkPopup={setShowConfirmLinkPopup}
        />
      )}

      {showPreview && (
        <PreviewAlbums
          item={singleImage}
          items={allImages}
          setShowPreview={setShowPreview}
          setShowAllImage={setShowAllImage}
        />
      )}

      {showConfirmLinkPopup && (
        <AVConfirmLinkPopup
          url={clickedUrl}
          handleCancel={() => setShowConfirmLinkPopup(false)}
        />
      )}

      {showLeagueTeamInvitePopup && (
        <AVLeagueInvitePopup
          isSuccess={true}
          leagueTeamInviteFrom={leagueTeamInviteFK}
          inviteToken={location?.state?.inviteToken ?? ""}
          showLeagueTeamInvitePopup={showLeagueTeamInvitePopup}
          setShowLeagueTeamInvitePopup={setShowLeagueTeamInvitePopup}
        />
      )}

      {showUnauthorizedDetails && <ErrorHandlerPopup />}
    </>
  );
};

export default React.memo(Teams);
